
/* LMM Relevanz-Ranking (Chris 2026-08-04) — EINE zentrale Rangfolge fuer
   Header-Dropdown und vollstaendige Suchseite.

   GRUNDREGEL: RELEVANZ VOR BESTSELLER (Chris 2026-08-13).
   Die Rangklassen werden strikt nacheinander bewertet. Ein Produkt einer
   schlechteren fachlichen Klasse kann ein Produkt einer besseren Klasse
   NIEMALS ueberholen — die Verkaufszahlen sortieren ausschliesslich
   INNERHALB derselben Klasse. Sterne und Bewertungsanzahl sind seit dem
   2026-08-13 KEIN Standardrangmerkmal mehr (Chris: Bestseller ersetzt die
   Sterne-Logik); sie bleiben berechnet fuer den manuell waehlbaren
   Suchseiten-Modus "Beste Bewertungen" und das DOM-Debugging.

   RANGKLASSEN
     0  exakter Identifikator (SKU, Barcode/EAN, MPN, gepflegter Alias)
     1  vollstaendige Deckung der ORIGINALEN Suchbestandteile im Artikelnamen
     2  exakte technische Uebereinstimmung   (Delegation an window.LMMTechRank)
     3  exakte Marke und exakte Serie
     4  teilweise Titeluebereinstimmung
     5  Treffer nur in strukturierten Produktdaten
   danach, nur bei gleicher Klasse:
     6  kaufbar/verfuegbar
     7  Bestseller-Rang -> Serverreihenfolge

   ERGAENZUNG 2026-08-04 (Korrekturrunde 2, Chris):
     · PRODUKTFAMILIE. Eine Roehrenanfrage ("LED Leuchtroehre", "LED Tube", …)
       erzeugt einen kanonischen Familien-Intent. Wer nicht zur Familie gehoert,
       ist fuer diese Anfrage kein fachlicher Treffer und wird auf die letzte
       Klasse gesetzt — sonst stand ein LED-TREIBER, dessen Titel "fuer LED
       Roehren" enthaelt, mit voller Titeldeckung vor jeder echten Roehre.
     · EIGENLEISTUNG != ERSATZLEISTUNG. specs.wattage und
       specs.replaces_wattage sind zwei verschiedene Aussagen. Eine 16-W-Anfrage
       ohne das Wort "LED" meint zuerst eine konventionelle 16-W-Roehre, danach
       den verifizierten LED-Ersatz FUER 16 W, und erst danach eine LED-Roehre,
       die selbst 16 W zieht, aber 36/38 W ersetzt.
     · PHRASE GANZ NACH UNTEN. Die Nachbarschaft zweier Suchwoerter im Titel
       stand bisher UEBER Verfuegbarkeit und Bewertung. Dadurch gewann
       "Philips TUV TL Mini 11W … (tuv 11w G11t5)" — der Klammerzusatz ist eine
       interne Schreibweise — gegen das besser bewertete PL-S 11W, und bei
       "827 G23 11W" standen zwei NICHT kaufbare Artikel vor einem kaufbaren.
       Die urspruengliche Schreibweise wirkt jetzt nur noch als letzter
       stabiler Tiebreaker (Chris Phase 3).

   ERGAENZUNG 2026-08-04 (Korrekturrunde 3, Chris):
     · PRODUKTGRUPPE im Rangvektor. Eine Sockel-/Bauformanfrage ("2g11") stellt
       Leuchtmittel vor Fassungen vor uebriges Zubehoer; ein ausdrueckliches
       Gruppenwort ("2g11 Fassung", "osram Vorschaltgeraet") stellt exakt diese
       Gruppe nach vorn. Wirkt auf Dropdown und Suchseite identisch.
     · KELVIN als hartes Merkmal: exakter Wert vor fehlendem vor abweichendem;
       Zuordnung Farbcode<->Kelvin ausschliesslich ueber die verifizierte
       Katalogregel (kelvinAusCode). 2700 K ist nicht 3000 K.
     · STANDARD- VOR SPEZIALANWENDUNG: generische Anfragen ("philips tl")
       stellen Allgemeinbeleuchtung vor TUV/UV-C/Actinic & Co.; ausdrueckliche
       Spezialanfragen stellen genau diese Anwendung nach vorn.
     · WATT ALLGEMEIN: tatsaechliche Eigenleistung zuerst; die Runde-2-Staffel
       gilt nur noch im Roehrenkontext (dort ist die Ersatzklasse laengen-
       kritisch); "Ersatz fuer 6W" stellt den verifizierten Ersatz nach vorn.
     · KOMPAKTE SCHREIBWEISEN ("13w840", "l36w", "g 9 2,6 w") werden beidseitig
       deterministisch zerlegt.

   ERGAENZUNG 2026-08-05 (Korrekturrunde 4, Chris):
     · HARTE QUERY-BEDINGUNGEN. Nennt die Anfrage ausdruecklich einen Sockel,
       eine Produktgruppe, eine Eigenleistung, eine Ersatzleistung (bei
       ausdruecklicher Ersatzabsicht), einen Kelvinwert, einen Farbcode oder
       eine Laenge, dann gilt je Merkmal: EXAKT vor UNBEKANNT vor WIDERSPRUCH.
       Ein Produkt mit einem strukturiert WIDERSPRECHENDEN Wert ist kein
       regulaerer Treffer (KLASSE.widerspruch) und wird von beiden Oberflaechen
       aus der regulaeren Produktliste ausgeschlossen. Titeldeckung, Bewertung,
       Bewertungsanzahl, Bestseller-Rang und Serverreihenfolge koennen einen
       harten Widerspruch NIEMALS ausgleichen. Belegte Fehlerfaelle 05.08.2026:
       "g 9 2,9 w" zeigte einen GU5.3-Spot, "leuchtmittel g9" eine
       Deckenleuchte und G24d-/G23-/G10q-Lampen, "Ersatz fuer 6W E27" Produkte
       mit EIGENLEISTUNG 6 W (ersetzt 42/45/60 W) an fremden Sockeln.
     · SOCKEL EXAKT: fuehrend ist das strukturierte Feld (specs.base); der
       Titel ist nur Rueckfallebene bei fehlendem Feld. Kanonischer Vergleich
       ueber LMMTechRank (G 9 == G9, GU5,3 == GU5.3) — niemals unscharf.
     · ERSATZABSICHT EXAKT: "Ersatz fuer 6W" verlangt replaces_wattage = 6.
       Eigenleistung 6 W mit ersetzt 42 W ist KEIN Ersatz fuer 6 W; ohne
       verifizierte Ersatzbeziehung gibt es keinen regulaeren Ersatztreffer.
     · SOCKEL-DEFAULT-REIHENFOLGE: Leuchtmittel -> Leuchten -> Fassungen ->
       uebriges Zubehoer (Chris Phase 5, "g9").

   ABGRENZUNG ZU SYNONYMEN (Chris): Ein kuratiertes Synonym darf zusaetzliche
   Kandidaten FINDEN, aber niemals einen exakten Original-Titeltreffer
   VORTAEUSCHEN. Klasse 1 wertet deshalb ausschliesslich Originaltokens nach
   sicherer Normalisierung (Ebene 1). Synonyme wirken erst ab Klasse 4.

   KEINE SKU-SONDERREGEL. Keine Artikelnummer, kein Produkt und keine Wattstufe
   ist irgendwo hart verdrahtet. */
(function () {
  'use strict';
  if (window.LMMRelevance) return;

  /* ============================================ Ebene 1 — sichere Normalisierung */
  /* Prototypenfreie Nachschlagetabelle: sonst wuerde ein Suchtoken wie
     "constructor" oder "tostring" faelschlich als Treffer gelten. */
  function objekt(quelle) {
    var o = Object.create(null);
    if (quelle) Object.keys(quelle).forEach(function (k) { o[k] = quelle[k]; });
    return o;
  }

  /* Curated whole words only. Model/identifier tokens are never typo-corrected. */
  var TYPO_TOKEN_MAP = [
    [/\b(?:philis|phillips|philipps)\b/g, 'philips'],
    [/\b(?:ostam|osrsm|osrams|osran|osrm|osra)\b/g, 'osram'],
    [/\b(?:substuitube|substitub)\b/g, 'substitube'],
    [/\blumiux\b/g, 'lumilux'], [/\bleuchtstofflame\b/g, 'leuchtstofflampe'],
    [/\bleuchtmitrel\b/g, 'leuchtmittel'], [/\bkaltweis\b/g, 'kaltweiss']
  ];
  function typoNormalisieren(text) {
    if (/\b\d{6,}\b|\b(?:sku|ean|gtin|barcode|artikelnummer)\s*:/i.test(text)) return text;
    function wort(re, ziel) {
      text = text.replace(re, function (m, offset, all) {
        if (/[a-z0-9_.\/-]/i.test(all.charAt(offset - 1)) || /[a-z0-9_.\/-]/i.test(all.charAt(offset + m.length))) return m;
        return ziel;
      });
    }
    TYPO_TOKEN_MAP.forEach(function (paar) { wort(paar[0], paar[1]); });
    if (/\b(?:osram|s|d|l|t|f|el|longlife|g23|g24|2g11|gx24|w|watt)\b/.test(text)) wort(/\bdelux\b/g, 'dulux');
    if (!/\bb15d?\b|\bhalolux\b/.test(text)) wort(/\bgobe\b/g, 'globe');
    if (/\b(?:led|spot|strahler|lampe|leuchtmittel|osram|philips|par16)\b|\d+\s*w\b/.test(text)) wort(/\bfu10\b/g, 'gu10');
    return text;
  }

  function grundNorm(v) {
    var s = String(v == null ? '' : v).replace(/[⁰¹²³⁴⁵⁶⁷⁸⁹₀₁₂₃₄₅₆₇₈₉]/g, function (c) {
      return String('⁰¹²³⁴⁵⁶⁷⁸⁹₀₁₂₃₄₅₆₇₈₉'.indexOf(c) % 10);
    }).toLowerCase();
    s = s.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
    if (s.normalize) s = s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    return s;
  }

  /* Wird BEIDSEITIG angewandt — auf die Query UND auf den Artikelnamen. Nur so
     ist "PL-S" == "PL S" == "PLS" und "11 Watt" == "11W" == "11-Watt". */
  function normalize(value) {
    var s = typoNormalisieren(grundNorm(value));
    if (window.LMMTechRank && window.LMMTechRank.zerlege) s = window.LMMTechRank.zerlege(s).text;
    s = s.replace(/(^|[^a-z0-9])(osram|philips|ledvance|radium|sylvania|megaman)(?=(?:led(?:star|tube|lamp\w*|roehr\w*|spot\w*|fluter\w*|panel\w*)?|dulux\w*|lumilux|parathom|substitube|corepro|master|halolux|halopin|haloline|decostar|halostar|star|value|performance|classic)\b)/g, '$1$2 ')
      .replace(/\bled\s*star\b/g, 'led star');
    s = s.replace(/[\u2010-\u2015\u2212]/g, '-');
    /* Serienschreibweisen zusammenziehen (laengste Muster zuerst). */
    s = s.replace(/\bpl\s*[-\/. ]?\s*([lcst])\b/g, 'pl$1');
    s = s.replace(/\bdulux\s*[-\/. ]?\s*([lcstdf])\b/g, 'dulux$1');
    s = s.replace(/\btl\s*[-\/. ]?\s*([d5])\b/g, 'tl$1');
    s = s.replace(/\blynx\s*[-\/. ]?\s*([lcs])\b/g, 'lynx$1');
    s = s.replace(/\bralux\s*[-\/. ]?\s*(?:rx[-\s]?)?([lcs])\b/g, 'ralux$1');
    /* CDM-Familien (Chris 2026-08-13, Exact-Family-Regel): "CDM-T", "CDM T"
       und "CDMT" fallen beidseitig auf EIN Token zusammen — und zwar je
       Familie getrennt (cdmt != cdmtc != cdmtd). Damit unterscheidet die
       Titeldeckung CDM-T von CDM-TC exakt wie Dulux L von Dulux D, ohne
       eigene Sonderklasse. Laengste Suffixe zuerst, sonst schluckt "t" das
       "tc". "cdm 220-240v" (Ziffern nach dem Suffix) bleibt unberuehrt. */
    s = s.replace(/\bcdm\s*[-\/. ]?\s*(r111|tc|td|tm|tw|t|r)\b/g, 'cdm$1');
    s = s.replace(/\bsubsti\s*tube\b/g, 'substitube');
    s = s.replace(/\bled\s*tube\b/g, 'led tube');
    s = s.replace(/\bsubstitub\b/g, 'substitube');
    s = s.replace(/\bledtube\b/g, 'led tube');
    /* Belegte Falschschreibungen aus den ECHTEN On-Site-Suchbegriffen
       (exports/google-ads-readonly/.../onsite_search_terms.csv, 12.06.2026):
       "osraml" mit 143 Sitzungen. Ohne diese Faltung fiel die Anfrage im
       Breitentest am 04.08.2026 auf Rangklasse 6 zurueck, obwohl der Kunde
       eindeutig Osram-L-Roehren sucht. "duluxd" (115) und "duluxs" (98)
       deckt die Dulux-Regel oben bereits ab, weil sie beidseitig auf Query
       UND Artikelnamen wirkt. */
    s = s.replace(/\bosraml\b/g, 'osram l');
    /* Sockel mit Dezimalstelle -> punktfreie Kanonform. */
    s = s.replace(/\bgu\s*5\s*[.,]\s*3\b/g, 'gu53');
    s = s.replace(/\bgy\s*6\s*[.,]\s*35\b/g, 'gy635');
    s = s.replace(/\bg\s*y\s*6\s*[.,]\s*35\b/g, 'gy635');
    s = s.replace(/\bp\s*14\s*[.,]\s*5\s*s\b/g, 'p145s');
    /* "G 23" -> "g23", "2 G 11" -> "2g11". */
    s = s.replace(/\b(2?g[uxyzr]?)\s+(\d{1,2})\b/g, '$1$2');
    s = s.replace(/\b(ba|bx|px|gx|gu|gy|gz)\s+(\d{1,2}[a-z]?)\b/g, '$1$2');
    /* Dezimaltrenner vereinheitlichen, aber nur zwischen Ziffern. */
    s = s.replace(/(\d)\s*,\s*(\d)/g, '$1.$2');
    /* Kompakte technische Schreibweisen zerlegen (Korrekturrunde 3, Chris
       Phase 5) — beidseitig auf Query UND Artikelnamen, damit "13w840" dieselben
       Tokens ergibt wie "13W/840". Deterministisch: Ziffern werden nie
       veraendert, nur Trennstellen eingefuegt. Serienbuchstabe+Watt bewusst NUR
       fuer l/t (Osram-L-/T-Nomenklatur) — "w5w" der Fahrzeuglampen bleibt. */
    s = s.replace(/(\d{1,3}(?:\.\d)?)\s*w([89](?:2[257]|3[035]|40|5[07]|6[05]))(?![0-9])/g, '$1w $2');
    s = s.replace(/(^|[^0-9])([89](?:2[257]|3[035]|40|5[07]|6[05]))([a-z]+\d)/g, '$1$2 $3');
    s = s.replace(/(^|[^a-z0-9])([lt])(\d{1,3}(?:\.\d)?w)(?=$|[^a-z0-9])/g, '$1$2 $3');
    /* WATT-BEREICHE aufspalten (Chris 2026-08-14, Dropdown "18W 830 led"):
       Multiwatt-Lampen heissen "18-36W" (Dulux L, CorePro LEDtube UN, T5 HE
       18-35W) — der Kunde tippt aber "18W". Der Bereich zaehlt beidseitig als
       BEIDE Einzelwerte, sonst verliert die fachlich richtige Lampe die
       Titeldeckung an ein Produkt mit zufaellig woertlicher Schreibweise.
       Die Schleife loest auch Ketten ("28-35-49-80W") vollstaendig auf.
       NUR fuer Watt — Volt ("220-240V"), Kelvin und Laengen bleiben
       unberuehrt, weil dort der Bereich keine Einzelwert-Zusage ist. */
    var wattBereich;
    do {
      wattBereich = s;
      s = s.replace(/(\d{1,3}(?:\.\d)?)\s*-\s*(\d{1,3}(?:\.\d)?)\s*(?:watt|w)\b/g, '$1w $2w');
    } while (s !== wattBereich);
    /* Einheiten anlegen. Reihenfolge: laengere Woerter vor kuerzeren Kuerzeln. */
    s = s.replace(/(\d{1,3}(?:\.\d)?)\s*-?\s*(?:watt|w)\b/g, '$1w');
    s = s.replace(/(\d{3,5})\s*-?\s*(?:kelvin|k)\b/g, '$1k');
    s = s.replace(/(\d{2,6})\s*-?\s*(?:lumen|lm)\b/g, '$1lm');
    s = s.replace(/(\d{2,5})\s*-?\s*(?:millimeter|mm)\b/g, '$1mm');
    s = s.replace(/(\d{1,2})\s*-?\s*(?:polig|pins?|p)\b/g, '$1p');
    s = s.replace(/(\d{1,3})\s*-?\s*(?:volt|v)\b/g, '$1v');
    /* Singular/Plural der haeufigen Grundwoerter. */
    s = s.replace(/\b(roehre|lampe|leuchte|birne|tube|spot|strahler|klemme|starter)n\b/g, '$1');
    s = s.replace(/\b(roehre|lampe|leuchte|birne|tube|spot|strahler|klemme|starter)s\b/g, '$1');
    return s.replace(/\s+/g, ' ').trim();
  }

  /* Generische Fuellwoerter. Bewusst kurz gehalten: jedes Wort hier senkt die
     Anforderung an Klasse 1. "led", "uv", Marken und Serien stehen NICHT drin. */
  var STOPP = objekt({
    'und': 1, 'oder': 1, 'der': 1, 'die': 1, 'das': 1, 'den': 1, 'dem': 1, 'des': 1,
    'ein': 1, 'eine': 1, 'einen': 1, 'fuer': 1, 'mit': 1, 'von': 1, 'im': 1, 'in': 1,
    'zu': 1, 'auf': 1, 'aus': 1, 'bei': 1, 'als': 1, 'ist': 1, 'sind': 1,
    /* 'durch' ergaenzt 2026-08-11: reine Praeposition derselben Klasse wie
       'fuer'/'mit'/'von' — in "X durch Y ersetzen" ein reines Beziehungswort
       ohne Produktbedeutung. Ohne diesen Eintrag entscheidet ein zufaelliges
       "Durchmesser" im Lieferantentitel ueber die Titeldeckung. Das Suchwort
       "durchmesser" bleibt als eigenes Token unberuehrt. */
    'durch': 1,
    'stk': 1, 'stueck': 1, 'set': 1, 'neu': 1, 'gut': 1, 'guenstig': 1, 'billig': 1,
    'kaufen': 1, 'online': 1, 'preis': 1, 'shop': 1
  });

  function tokens(value) {
    var out = [];
    normalize(value).split(/[^a-z0-9.]+/).forEach(function (raw) {
      var t = raw.replace(/^\.+|\.+$/g, '');
      if (!t) return;
      if (t.length < 2 && !/^\d$/.test(t)) return;
      out.push(t);
    });
    return out;
  }

  function wesentlich(list) {
    var out = [], gesehen = objekt(null);
    list.forEach(function (t) {
      if (STOPP[t] || gesehen[t]) return;
      gesehen[t] = 1;
      out.push(t);
    });
    return out;
  }

  /* ================================================= Ebene 2 — kuratierte Synonyme */
  /* Wirken AUSSCHLIESSLICH ab Klasse 4 (Teiluebereinstimmung) und in Klasse 5.
     Exakte technische Werte stehen bewusst NICHT drin: 827 != 830,
     2700 K != 3000 K, GU5.3 != MR16, TUV != jedes UV-C-Produkt,
     PL-S != jede verwandte Kompaktlampenserie. */
  var SYNONYM = objekt({
    'leuchtroehre': ['roehre', 'leuchtstoffroehre', 'tube', 't8', 't5'],
    'leuchtstoffroehre': ['roehre', 'leuchtroehre', 'tube'],
    'neonroehre': ['roehre', 'leuchtstoffroehre', 'leuchtroehre', 'tube'],
    'roehre': ['tube', 'leuchtstoffroehre', 'leuchtroehre'],
    'tube': ['roehre', 'leuchtstoffroehre'],
    'entkeimung': ['uvc', 'uv-c', 'tuv', 'hns', 'germicidal', 'puritec'],
    'uvc': ['entkeimung', 'tuv', 'hns', 'germicidal'],
    'germicidal': ['entkeimung', 'uvc'],
    'kompaktleuchtstofflampe': ['kll', 'dulux', 'pll', 'plc', 'pls', 'plt'],
    'kll': ['kompaktleuchtstofflampe', 'dulux'],
    'warmweiss': ['827', '830', '2700k', '3000k'],
    'neutralweiss': ['840', '4000k'],
    'tageslichtweiss': ['865', '6500k'],
    'kaltweiss': ['kaltweiss', 'neutralweiss', '4000k', '840', 'cool white'],
    'kaltweiß': ['kaltweiss', 'neutralweiss', '4000k', '840', 'cool white'],
    'parathom': ['superstar', 'star', 'ledvance'],
    'halogenstab': ['r7s', 'haloline', 'stab'],
    'sparlampe': ['energiesparlampe', 'kll', 'dulux'],
    'klemme': ['wago', 'verbinder', 'dosenklemme'],
    'verbinder': ['klemme', 'wago'],
    'trafo': ['transformator', 'netzteil', 'treiber', 'driver'],
    'netzteil': ['trafo', 'treiber', 'driver'],
    'evg': ['vorschaltgeraet', 'betriebsgeraet'],
    'kvg': ['vorschaltgeraet', 'betriebsgeraet'],
    'vorschaltgeraet': ['evg', 'kvg', 'vvg', 'betriebsgeraet']
  });

  function synonymeFuer(t) {
    return SYNONYM[t] || null;
  }

  /* ============================================ Identifikatoren (eine Definition) */
  /* EINZIGE Erkennung im gesamten Theme. Ersetzt die drei bisher abweichenden
     Definitionen (RE_IDENT >=6 Ziffern, identifierQuery 8-14, der
     Liquid-Flag 8/12/13/14). Bindestriche und Leerzeichen werden entfernt,
     weil EAN/GTIN und Artikelnummern in beiden Schreibweisen eingegeben
     werden ("4058075 139688"). Fuehrende Nullen bleiben erhalten — sie werden
     erst beim FELDVERGLEICH beidseitig abgeschnitten, nie beim Erkennen. */
  var RE_NUR_ZIFFERN = /^[0-9]+$/;

  var RE_FELD_PREFIX = /^\s*variants\.(?:sku|barcode):\s*/i;

  function identAnzeige(value) {
    return String(value == null ? '' : value).replace(RE_FELD_PREFIX, '');
  }

  function identKompakt(value) {
    return identAnzeige(value).replace(/[\s\-.\u2010-\u2015]/g, '');
  }

  function feldSuche(value) {
    var roh = String(value == null ? '' : value).trim();
    if (!roh) return '';
    var k = identKompakt(roh);
    if (RE_NUR_ZIFFERN.test(k)) {
      if (k.length === 10) return 'variants.sku:' + k;
      if (k.length === 13) return 'variants.barcode:' + k;
    }
    return roh;
  }

  function identifierQuery(value) {
    var k = identKompakt(value);
    if (!RE_NUR_ZIFFERN.test(k)) return null;
    if (k.length < 8 || k.length > 14) return null;
    return k;
  }

  /* Vergleich fuer SKU/MPN/Alias: exakt nach Kompaktierung, zusaetzlich mit
     beidseitig entfernten fuehrenden Nullen. KEINE Fuzzy-Naeherung. */
  function ohneFuehrendeNullen(s) {
    var t = String(s || '').replace(/^0+/, '');
    return t === '' ? '0' : t;
  }

  function identGleich(a, b) {
    if (!a || !b) return false;
    var ka = identKompakt(a), kb = identKompakt(b);
    if (!ka || !kb) return false;
    if (ka === kb) return true;
    if (RE_NUR_ZIFFERN.test(ka) && RE_NUR_ZIFFERN.test(kb)) {
      return ohneFuehrendeNullen(ka) === ohneFuehrendeNullen(kb);
    }
    return false;
  }

  /* GTIN-Vergleich: nur fachlich gueltige Darstellungen derselben Nummer.
     GTIN-8/12/13/14 sind links mit Nullen auf 14 Stellen aufgefuellt identisch.
     Andere Laengen werden NICHT aufgefuellt — sonst wuerde eine beliebige
     Ziffernfolge zur EAN erklaert. */
  var GTIN_LAENGEN = objekt({ 8: 1, 12: 1, 13: 1, 14: 1 });

  function gtin14(value) {
    var k = identKompakt(value);
    if (!RE_NUR_ZIFFERN.test(k) || !GTIN_LAENGEN[k.length]) return null;
    while (k.length < 14) k = '0' + k;
    return k;
  }

  function gtinGleich(a, b) {
    var ga = gtin14(a), gb = gtin14(b);
    return !!ga && !!gb && ga === gb;
  }

  /* ================================================== Marken und Serien (Klasse 3) */
  var MARKEN = [
    { key: 'philips', muster: /\bphilips\b|\bsignify\b/, werte: ['philips', 'signify'] },
    { key: 'osram', muster: /\bosram\b|\bledvance\b/, werte: ['osram', 'ledvance'] },
    { key: 'sylvania', muster: /\bsylvania\b/, werte: ['sylvania'] },
    { key: 'radium', muster: /\bradium\b/, werte: ['radium'] },
    { key: 'megaman', muster: /\bmegaman\b/, werte: ['megaman'] },
    { key: 'patron', muster: /\bpatron\b/, werte: ['patron'] },
    { key: 'modee', muster: /\bmodee\b/, werte: ['modee'] },
    { key: 'evn', muster: /\bevn\b/, werte: ['evn'] },
    { key: 'varta', muster: /\bvarta\b/, werte: ['varta'] },
    { key: 'duracell', muster: /\bduracell\b/, werte: ['duracell'] },
    { key: 'wago', muster: /\bwago\b/, werte: ['wago'] },
    { key: 'mennekes', muster: /\bmennekes\b/, werte: ['mennekes'] }
  ];

  /* Serien sind herstellergebunden. Eine Serienangabe impliziert die Marke,
     bleibt aber ein EIGENES Merkmal: "TUV" ist nicht jedes UV-C-Produkt,
     "PL-S" nicht jede verwandte Kompaktlampenserie. */
  var SERIEN = [
    { key: 'tuv', muster: /\btuv\b/, marke: 'philips' },
    { key: 'hns', muster: /\bhns\b/, marke: 'osram' },
    { key: 'puritec', muster: /\bpuritec\b/, marke: 'osram' },
    { key: 'pls', muster: /\bpls\b/, marke: 'philips' },
    { key: 'pll', muster: /\bpll\b/, marke: 'philips' },
    { key: 'plc', muster: /\bplc\b/, marke: 'philips' },
    { key: 'plt', muster: /\bplt\b/, marke: 'philips' },
    { key: 'master', muster: /\bmaster\b/, marke: 'philips' },
    { key: 'corepro', muster: /\bcorepro\b/, marke: 'philips' },
    { key: 'tld', muster: /\btld\b/, marke: 'philips' },
    { key: 'tl5', muster: /\btl5\b/, marke: 'philips' },
    { key: 'actinic', muster: /\bactinic\b/, marke: 'philips' },
    { key: 'plusline', muster: /\bplusline\b/, marke: 'philips' },
    { key: 'tornado', muster: /\btornado\b/, marke: 'philips' },
    { key: 'duluxs', muster: /\bduluxs\b/, marke: 'osram' },
    { key: 'duluxd', muster: /\bduluxd\b/, marke: 'osram' },
    { key: 'duluxl', muster: /\bduluxl\b/, marke: 'osram' },
    { key: 'duluxt', muster: /\bduluxt\b/, marke: 'osram' },
    { key: 'duluxf', muster: /\bduluxf\b/, marke: 'osram' },
    { key: 'dulux', muster: /\bdulux\b/, marke: 'osram' },
    { key: 'lumilux', muster: /\blumilux\b/, marke: 'osram' },
    { key: 'substitube', muster: /\bsubstitube\b/, marke: 'osram' },
    { key: 'parathom', muster: /\bparathom\b/, marke: 'osram' },
    { key: 'haloline', muster: /\bhaloline\b/, marke: 'osram' },
    { key: 'decostar', muster: /\bdecostar\b/, marke: 'osram' },
    { key: 'halostar', muster: /\bhalostar\b/, marke: 'osram' },
    { key: 'halopin', muster: /\bhalopin\b/, marke: 'osram' },
    { key: 'powerball', muster: /\bpowerball\b/, marke: 'osram' },
    { key: 'xenophot', muster: /\bxenophot\b/, marke: 'osram' },
    { key: 'lynx', muster: /\blynx[lcs]?\b/, marke: 'sylvania' },
    { key: 'grolux', muster: /\bgrolux\b/, marke: 'sylvania' },
    { key: 'ralux', muster: /\bralux[lcs]?\b/, marke: 'radium' },
    { key: 'bonalux', muster: /\bbonalux\b/, marke: 'radium' },
    /* Korrekturrunde 3 (Chris Phase 6): "TL" und "PL" sind die Philips-
       Nomenklatur als GANZES. Wer "philips tl" sucht, meint TL/TL-D/TL5 —
       das Muster deckt die Serienschreibweisen ab, die normalize() beidseitig
       zusammenzieht (tld, tl5, pll, plc, pls, plt). */
    { key: 'tl', muster: /\btl[d5]?\b/, marke: 'philips' },
    { key: 'pl', muster: /\bpl[lcst]?\b/, marke: 'philips' }
  ];

  function erkenneMarke(norm) {
    for (var i = 0; i < MARKEN.length; i++) {
      if (MARKEN[i].muster.test(norm)) return MARKEN[i];
    }
    return null;
  }

  function erkenneSerien(norm) {
    var out = [];
    for (var i = 0; i < SERIEN.length; i++) {
      if (SERIEN[i].muster.test(norm)) out.push(SERIEN[i]);
    }
    /* "duluxs" trifft auch /\bdulux\b/ nicht (Wortgrenze), umgekehrt schon nicht.
       Trotzdem doppelte Familien entfernen, falls kuenftig Muster ueberlappen. */
    return out;
  }

  /* ================= Technologie, Produktfamilie, Eigen-/Ersatzleistung ====
     Alles in diesem Block ist KURATIERT und datengestuetzt. Es gibt keine
     SKU-Sonderregel und keine hart verdrahtete Wattstufe. */

  /* Technologieangabe der ANFRAGE. Nur ein ausdrueckliches "led" zaehlt —
     aus einem Produkttitel wird nichts zurueckgeschlossen. */
  function technologieVonQuery(norm) {
    return /\bled\b/.test(norm) ? 'led' : null;
  }

  /* Roehrenbegriffe der ANFRAGE. Geprueft wird ueber TOKENS, nicht ueber
     Teilstrings: ein zufaelliges "tube" in einer Artikelnummer darf keine
     Familie ausloesen. */
  var ROEHREN_BEGRIFF = objekt({
    'roehre': 1, 'leuchtroehre': 1, 'leuchtstoffroehre': 1, 'neonroehre': 1,
    'roehrenlampe': 1, 'tube': 1
  });

  /* Kuratierte Produktfamilien. FUEHRENDE Quelle ist der gepflegte
     Shopify-Produkttyp ("LED-Roehren", "Leuchtstoffroehren", "Leuchten",
     "Vorschaltgeraete/Treiber") — er ist belastbarer als jeder Titeltext.
     Titelmarker greifen nur bei Produkten ganz OHNE Typ. */
  var FAMILIEN = [
    {
      key: 'led_roehre',
      technologie: 'led',
      typen: objekt({ 'led-roehren': 1 }),
      marker: /\b(?:roehre|tube|ledtube|substitube|t5|t8|t12|tl|tld|tl5)\b/,
      /* KANONISCHER nativer Suchbegriff. Shopify liefert je Schreibweise einen
         anderen Bestand — gemessen am 04.08.2026 auf dem Canary:
           "LED Leuchtroehre"      -> 1030013649 gar nicht im Kandidatenpool
           "LED Leuchtstoffroehre" -> 1030013649 vorhanden, korrekt auf Rang 1
           "LED Tube"              -> vollstaendiger, roehrenreiner Bestand
         Alle Schreibweisen laden deshalb zusaetzlich diesen einen Begriff.
         Die ANGEZEIGTE Suchanfrage bleibt unveraendert. */
      nativeQuery: 'LED Tube'
    },
    {
      key: 'leuchtstoffroehre',
      technologie: null,
      typen: objekt({ 'leuchtstoffroehren': 1 }),
      marker: /\b(?:roehre|leuchtstoffroehre|t5|t8|t12|tl|tld|tl5)\b/,
      nativeQuery: 'Leuchtstoffr\u00f6hre'
    }
  ];

  /* Negative Abgrenzung (Chris Phase 3) — greift nur bei Produkten ohne
     gepflegten Typ. Mit Typ entscheidet der Typ allein. */
  var NEGATIV_TITEL = /\b(?:leuchte|deckenleuchte|wandleuchte|aussenleuchte|lichtervorhang|bodeneinbauleuchte|kleinleuchte|moebelleuchte|strahler|panel)\b/;

  function familieVonQuery(tokenListe, norm) {
    var hatRoehre = false;
    for (var i = 0; i < tokenListe.length; i++) {
      if (ROEHREN_BEGRIFF[tokenListe[i]]) { hatRoehre = true; break; }
    }
    if (!hatRoehre) return null;
    var tech = technologieVonQuery(norm);
    for (var j = 0; j < FAMILIEN.length; j++) {
      if (FAMILIEN[j].technologie === tech) return FAMILIEN[j];
    }
    return null;
  }

  function typKanon(wert) {
    return grundNorm(wert || '').replace(/\s+/g, '');
  }

  /* 0 = gepflegter Familientyp · 1 = Titelmarker bei fehlendem Typ ·
     2 = gehoert nicht zur Familie. */
  function familieTrifft(fam, p, idx) {
    var typ = typKanon(p && p.typ);
    if (typ) return fam.typen[typ] ? 0 : 2;
    if (NEGATIV_TITEL.test(idx.norm)) return 2;
    if (!fam.marker.test(idx.norm)) return 2;
    var istLed = /\bled\b/.test(idx.norm);
    if (fam.technologie === 'led' && !istLed) return 2;
    if (fam.technologie === null && istLed) return 2;
    return 1;
  }

  function zahlOderNaN(v) {
    if (v === null || v === undefined || v === '') return NaN;
    var n = Number(String(v).replace(',', '.'));
    return isFinite(n) ? n : NaN;
  }

  /* Eigenleistung (specs.wattage) und Ersatzleistung (specs.replaces_wattage)
     duerfen nicht in dieselbe Bedeutung fallen (Chris Phase 6/7/8; verbindliche
     Endfassung Korrekturrunde 3, Chris Phase 7).

     ALLGEMEINE Regel (kein Roehrenkontext, keine Ersatzabsicht):
       0  tatsaechliche Eigenleistung exakt  ("6W E27" -> echte 6-W-Lampe,
          auch wenn sie zusaetzlich eine andere Leistung ersetzt)
       1  verifizierter Ersatz fuer die gesuchte Leistung
       3  keine Beziehung zur gesuchten Leistung

     ROEHRENKONTEXT (Familienwort oder Roehrensockel G13/G5/2GX13) OHNE "LED" —
     die Runde-2-Staffel bleibt unveraendert, weil die Ersatzklasse dort
     laengen-/systemkritisch ist ("16W/840 G13"):
       0  konventionelle Roehre mit der gesuchten Leistung
       1  verifizierter Ersatz FUER die gesuchte Leistung
       2  verbraucht die gesuchte Leistung, ersetzt aber eine ANDERE
       3  keine Beziehung

     Anfrage MIT "LED": tatsaechliche LED-Eigenleistung zuerst (0), danach der
     verifizierte Ersatz (1) — unveraendert.
     AUSDRUECKLICHE Ersatzabsicht ("Ersatz fuer 6W"): verifizierter Ersatz darf
     zuerst stehen (0), die Eigenleistung folgt (1). */
  function roehrenKontext(analyse) {
    if (analyse.familie) return true;
    return !!(analyse.tech && analyse.tech.roehrenKontext);
  }

  /* Verifizierter Ersatz: exakter Wert ODER — ausserhalb des Roehrenkontexts —
     dieselbe Ersatzklasse des Leuchtmittel-Finders ("~50 W" = 50-55 W; Chris
     Phase 12, 2026-08-13: der 51-W-Spot gehoert zur 50-W-Anfrage). Bei
     Roehren bleibt der Ersatzwert exakt (laengen-/systemkritisch). */
  function ersatzTrifft(analyse, pr, qw) {
    if (!isFinite(pr)) return false;
    if (Math.abs(pr - qw) < 0.05) return true;
    if (roehrenKontext(analyse)) return false;
    var T = window.LMMTechRank;
    if (!T || typeof T.ersatzKlasse !== 'function') return false;
    var kl = T.ersatzKlasse(qw);
    return !!kl && pr >= kl[0] && pr <= kl[1];
  }

  function wattStufe(analyse, p) {
    var roh = analyse.tech ? analyse.tech.watt : null;
    if (roh === null || roh === undefined || !isFinite(Number(roh))) return 0;
    var qw = Number(roh);
    var pw = zahlOderNaN(p && p.watt);
    var pr = zahlOderNaN(p && p.ersatzWatt);
    var direkt = isFinite(pw) && Math.abs(pw - qw) < 0.05;
    var ersatz = ersatzTrifft(analyse, pr, qw);
    if (analyse.tech && analyse.tech.ersatzAbsichtStark) {
      /* KORREKTURRUNDE 4 (Chris Phase 8): "Ersatz fuer 6W" verlangt die
         verifizierte Ersatzleistung. Ein Produkt, das selbst 6 W verbraucht,
         aber nachweislich eine ANDERE Leistung ersetzt, ist KEIN Ersatz fuer
         6 W (harter Widerspruch, siehe harteBedingungen). Ist die
         Ersatzleistung unbekannt, bleibt nur die schwache unbekannte Stufe —
         eine Titelangabe wird nie als verifizierte Ersatzbeziehung behandelt
         (Chris Phase 9). */
      if (ersatz) return 0;
      if (direkt && !isFinite(pr)) return 2;
      return 3;
    }
    if (analyse.technologie === 'led') {
      if (direkt) return 0;
      if (ersatz) return 1;
      return 3;
    }
    if (roehrenKontext(analyse)) {
      if (direkt && (!isFinite(pr) || ersatz)) return 0;
      if (ersatz) return 1;
      if (direkt) return 2;
      return 3;
    }
    if (direkt) return 0;
    if (ersatz) return 1;
    return 3;
  }

  /* Kelvin als hartes technisches Merkmal (Korrekturrunde 3, Chris Phase 4).
     Nur bei ausdruecklichem Kelvinwert in der Query:
       0 exakter Wert (specs.kelvin oder verifizierter Farbcode via
         kelvinAusCode — 827<->2700, 830<->3000, 840<->4000, 865<->6500)
       1 Wert am Produkt unbekannt (Datenluecke, kein Ausschluss)
       2 abweichender Wert — darf NIE per Bewertung/Bestseller/Marke vor einen
         exakten Wert rutschen (Schluesselposition vor allen Weichfaktoren).
     Keine Naeherung: 2700 K ist nicht 3000 K. Toleranz nur fuers Runden. */
  function kelvinStufe(analyse, p) {
    var qk = analyse.tech && analyse.tech.kelvin !== null && analyse.tech.kelvin !== undefined
      ? Number(analyse.tech.kelvin) : NaN;
    if (!isFinite(qk)) return 0;
    var pk = zahlOderNaN(p && p.kelvin);
    if (!isFinite(pk) && p && p.farbcode && window.LMMTechRank) {
      var via = window.LMMTechRank.kelvinAusCode(String(p.farbcode).trim());
      if (via) pk = Number(via);
    }
    if (!isFinite(pk)) return 1;
    return Math.abs(pk - qk) < 51 ? 0 : 2;
  }

  /* Lichtstrom, wenn ausdruecklich gesucht ("180lm"): ungefaehr passend (±10 %)
     vor unbekannt vor abweichend. Kein Filter, keine Alternative aus Lumen. */
  function lumenStufe(analyse, p) {
    var ql = analyse.tech && analyse.tech.lumen !== null && analyse.tech.lumen !== undefined
      ? Number(analyse.tech.lumen) : NaN;
    if (!isFinite(ql) || ql <= 0) return 0;
    var pl = zahlOderNaN(p && p.lumen);
    if (!isFinite(pl)) return 1;
    return Math.abs(pl - ql) <= Math.max(ql * 0.1, 10) ? 0 : 2;
  }

  /* ============================ Produktgruppen (Korrekturrunde 3, Phase 3) ==
     Klassen: leuchtmittel · fassung · treiber · leuchte · zubehoer.
     FUEHRENDE Quelle ist der gepflegte Shopify-Produkttyp (vollstaendige,
     katalogverifizierte Liste vom 04.08.2026); der grobe Suchseiten-Bucket
     (lmm-search-classify) und Titelmarker sind Rueckfallebenen. */
  var BUCKET_TYPEN = objekt({
    'leuchten': 'leuchte',
    'vorschaltgeraete/treiber': 'treiber',
    'zubehoer': 'zubehoer',
    'elektroinstallation/wago': 'zubehoer',
    'batterien': 'zubehoer',
    'led-lampen': 'leuchtmittel',
    'kompaktleuchtstoff': 'leuchtmittel',
    'leuchtstoffroehren': 'leuchtmittel',
    'led-roehren': 'leuchtmittel',
    'halogen': 'leuchtmittel',
    'entladungslampen': 'leuchtmittel',
    'gluehlampen': 'leuchtmittel',
    'speziallampen': 'leuchtmittel',
    'studio/projektion/foto': 'leuchtmittel',
    'fahrzeugbeleuchtung': 'leuchtmittel',
    /* grobe Suchseiten-Buckets (data-ptype) als Rueckfallebene */
    'leuchtmittel': 'leuchtmittel',
    'leuchte': 'leuchte',
    'adapter': 'fassung'
  });

  var RE_FASSUNG_TITEL = /fassung(?:en)?\b|\bhalter\b|lampenhalter\w*|sockeladapter\w*|lampenadapter\w*|\badapter\b/;
  var RE_LEUCHTE_TITEL = /leuchten?\b|einbaustrahler\w*|aufbaustrahler\w*|wandstrahler\w*|downlight\w*|lichtleiste\w*|\bpanel\b/;
  var RE_TREIBER_TITEL = /vorschaltgeraet\w*|betriebsgeraet\w*|\bevg\b|\bkvg\b|\bvvg\b|treiber\b|netzteil\w*|\btrafo\b|transformator\w*|\bdriver\b/;
  var RE_ZUBEHOER_TITEL = /\bstarter\b|halteclip\w*|\bklemme\b|verbinder\w*|abdeckung\w*|montage\w*/;

  function bucketVonProdukt(p, idx) {
    var b = BUCKET_TYPEN[typKanon(p && p.typ)] || null;
    if (!b && p && p.bucket) b = BUCKET_TYPEN[typKanon(p.bucket)] || null;
    /* Fassungen stecken im Katalog unter Zubehoer/Elektroinstallation —
       der Titel entscheidet die Feinklasse ("Houben Fassung 2G11"). */
    if ((b === 'zubehoer' || !b) && RE_FASSUNG_TITEL.test(idx.norm)) return 'fassung';
    if (b) return b;
    if (RE_TREIBER_TITEL.test(idx.norm)) return 'treiber';
    if (RE_LEUCHTE_TITEL.test(idx.norm)) return 'leuchte';
    if (RE_ZUBEHOER_TITEL.test(idx.norm)) return 'zubehoer';
    return 'leuchtmittel';
  }

  /* Ausdruecklicher Produktgruppen-Intent der QUERY (kuratierte Listen, Chris
     Phase 3). Reihenfolge = Vorrang: Wer "2g11 Fassung" tippt, will Fassungen,
     obwohl 2G11 ein Lampensockel ist. */
  var GRUPPEN_INTENT = [
    { key: 'fassung', muster: /fassung(?:en)?\b|\bhalter\b|lampenhalter\w*|sockelhalter\w*/ },
    { key: 'treiber', muster: /vorschaltgeraet\w*|betriebsgeraet\w*|\bevg\b|\bkvg\b|\bvvg\b|\btreiber\b|\bdriver\b|netzteil\w*|\btrafo\b|transformator\w*/ },
    { key: 'leuchte', muster: /leuchten?\b|\bstrahler\b|strahlergehaeuse\w*|\bpanel\b|downlight\w*/ },
    { key: 'zubehoer', muster: /zubehoer\b|\badapter\b|sockeladapter\w*|verbinder\w*|\bstarter\b|halteclip\w*|\bmontage\b|\bklemme\b/ },
    { key: 'leuchtmittel', muster: /lampen?\b|leuchtmittel\b|birnen?\b|roehren?\b|\btubes?\b|\bdulux\w*|\bpl[lcst]\b|\btld\b|\btl5\b|\bt5\b|\bt8\b|\bt12\b|\bmr11\b|\bmr16\b|\bhalogen\b|kompaktleuchtstofflampe\w*|energiesparlampe\w*/ }
  ];

  /* Wortmuster einer Produktgruppe — EINE Definition fuer die harte
     Gruppenpruefung UND die weiche Rangstufe. Vorher stand die Schleife nur
     inline in harteBedingungen; damit konnten beide Stufen auseinanderlaufen
     (genau das war die Ursache des Starter-Befunds vom 13.08.2026). */
  function musterVonGruppe(key) {
    for (var i = 0; i < GRUPPEN_INTENT.length; i++) {
      if (GRUPPEN_INTENT[i].key === key) return GRUPPEN_INTENT[i].muster;
    }
    return null;
  }

  function bucketIntent(analyse) {
    var lampenSignal = !!(analyse.tech
      && (analyse.tech.watt !== null || analyse.tech.farbcode || analyse.tech.sockel));
    for (var i = 0; i < GRUPPEN_INTENT.length; i++) {
      var g = GRUPPEN_INTENT[i];
      if (!g.muster.test(analyse.norm)) continue;
      /* "dulux d 18w/840 fassung g24d-2" beschreibt den SOCKEL der Lampe —
         eine Fassungssuche liegt nur ohne Lampensignale vor (Watt, Farbcode,
         erkannte Serie). "g9 fassung" bleibt eine echte Fassungssuche. */
      if (g.key === 'fassung'
          && (analyse.serien.length
              || (analyse.tech && (analyse.tech.watt !== null || analyse.tech.farbcode)))) {
        continue;
      }
      /* EVG/KVG/VVG ohne starkes Geraetewort: bei gleichzeitigem Leuchtmittel-
         wort oder Sockel ist die Anfrage eine LAMPENSUCHE fuer diese
         Betriebsart, keine Geraetesuche. */
      if (g.key === 'treiber'
          && !/vorschaltgeraet\w*|betriebsgeraet\w*|\btreiber\b|\bdriver\b|netzteil\w*|\btrafo\b|transformator\w*/.test(analyse.norm)
          && (lampenSignal || GRUPPEN_INTENT[4].muster.test(analyse.norm))) {
        continue;
      }
      return { modus: 'explizit', key: g.key };
    }
    /* Nur ein Lampensockel, kein Gruppenwort: Leuchtmittel zuerst, Fassungen
       danach, Rest dahinter (Beispiel "2g11", Chris Phase 3). */
    if (analyse.tech && analyse.tech.sockel) return { modus: 'sockel', key: 'leuchtmittel' };
    /* LAMPEN-SPEC-ANFRAGE (Chris 2026-08-14, Dropdown "18W 830 led"): Watt plus
       Lichtfarbe (Farbcode oder Kelvin) beschreibt ein LEUCHTMITTEL — dieselbe
       fachliche Regel wie der Sockel-Default oben und classify-Ausschluss 2.
       Ohne diesen Intent blieb der bucket-Schluessel bei solchen Anfragen fuer
       ALLE Produkte 0, und ein Downlight mit woertlicher Titeldeckung
       ("18W/830") stand vor der fachlich richtigen Dulux L ("18-36W/830").
       Bewusst NICHT bei Watt allein (zu breit); ein Gruppenwort (Leuchte,
       Fassung, Treiber, ...) hat die Schleife oben bereits entschieden.
       modus 'spec' prueft NIE hart (harteBedingungen verlangt 'explizit') —
       Leuchten bleiben auffindbar, nur hinter den Leuchtmitteln. */
    if (analyse.tech && analyse.tech.watt !== null && analyse.tech.watt !== undefined
        && (analyse.tech.farbcode
            || (analyse.tech.kelvin !== null && analyse.tech.kelvin !== undefined))) {
      return { modus: 'spec', key: 'leuchtmittel' };
    }
    return null;
  }

  /* Wie bucketVonProdukt, aber NUR mit belegter Quelle: gepflegter Typ,
     Suchseiten-Bucket oder eindeutiger Titelmarker. Ohne Beleg: null
     (UNBEKANNT) — fuer die harte Gruppenpruefung darf der Standardwert
     "leuchtmittel" keinen Widerspruch vortaeuschen (Korrekturrunde 4). */
  function bucketBekannt(p, idx) {
    var b = BUCKET_TYPEN[typKanon(p && p.typ)] || null;
    if (!b && p && p.bucket) b = BUCKET_TYPEN[typKanon(p.bucket)] || null;
    if ((b === 'zubehoer' || !b) && RE_FASSUNG_TITEL.test(idx.norm)) return 'fassung';
    if (b) return b;
    if (RE_TREIBER_TITEL.test(idx.norm)) return 'treiber';
    if (RE_LEUCHTE_TITEL.test(idx.norm)) return 'leuchte';
    if (RE_ZUBEHOER_TITEL.test(idx.norm)) return 'zubehoer';
    return null;
  }

  /* Ein Produkt kann fachlich zu MEHREREN Gruppen gehoeren. bucketVonProdukt
     liefert nur die Primaergruppe aus dem gepflegten product.type; das reicht
     nicht, wenn der gepflegte Typ die fachliche Zugehoerigkeit verfehlt.
     Belegt am 13.08.2026: ALLE zehn echten Roehrenstarter (Osram St111/St151/
     St173, Philips S10/S2/S10E, GE, Radium RS, Philips BodyTone) sind als
     product.type "Leuchtstoffroehren" gepflegt und tragen das korrekte
     custom.product_kind "starter"; der LED-T8-Tube-Starter ist umgekehrt als
     product.type "Zubehoer" gepflegt. Bei der Anfrage "starter" bekam damit
     ausgerechnet der schwaechste Starter (Rang 406) Bucketstufe 0 und der
     meistbestellte (Philips S10, Rang 14) Stufe 1 — und weil bucket
     Kaskadenschluessel 8 ist und best Schluessel 16, konnte der Verkaufsrang
     das nie einholen.
     Diese Funktion sammelt deshalb ALLE belegten Gruppen: Primaergruppe,
     gepflegtes custom.product_kind (ueber den Suchseiten-Bucket) und
     eindeutige Titelmarker. Gleiches Muster wie spezialKeys/anwendungStufe.
     Die Zubehoer-Klassifikation wird dadurch NICHT entfernt — sie wird nur
     nicht mehr exklusiv. */
  function gruppeBelegt(p, idx, key) {
    if (bucketVonProdukt(p, idx) === key) return true;
    if ((BUCKET_TYPEN[typKanon(p && p.bucket)] || null) === key) return true;
    var m = musterVonGruppe(key);
    return !!(m && m.test(idx.norm));
  }

  function bucketStufe(analyse, p, idx) {
    var intent = analyse.gruppe;
    if (!intent) return 0;
    var b = bucketVonProdukt(p, idx);
    if (intent.modus === 'explizit') return gruppeBelegt(p, idx, intent.key) ? 0 : 1;
    /* Sockel-Default (Korrekturrunde 4, Chris Phase 5): Leuchtmittel zuerst,
       dann Leuchten, dann Fassungen, dann uebriges Zubehoer. */
    if (b === 'leuchtmittel') return 0;
    if (b === 'leuchte') return 1;
    if (b === 'fassung') return 2;
    return 3;
  }

  /* ================== Standard- vor Spezialanwendung (Runde 3, Phase 6) ====
     Kuratierte Spezialanwendungen — aus den gepflegten Serien (TUV, HNS,
     Puritec, Actinic, Grolux/Fluora) und der verbindlichen Liste des Auftrags.
     Eine GENERISCHE Anfrage stellt Standardprodukte vor Spezialanwendungen;
     eine ausdrueckliche Spezialanfrage stellt genau diese Anwendung nach vorn.
     Keine Marke und keine SKU ist hier verdrahtet. */
  var SPEZIAL = [
    { key: 'uv', muster: /\btuv\b|\buvc?-?c?\b|uv-?c\b|entkeim\w*|germicidal\w*|puritec\b|\bhns\b|actinic\b|schwarzlicht\w*|blacklight\w*|\buv-?a\b|\buv-?b\b|lichttherapie\w*/ },
    { key: 'pflanze', muster: /pflanzenlampe\w*|pflanzenleucht\w*|\bgrow\b|fluora\b|grolux\b/ },
    { key: 'insekt', muster: /insekten\w*|muecken\w*/ },
    { key: 'medizin', muster: /medizinisch\w*|therapie\w*/ },
    { key: 'geraet', muster: /backofen\w*|kuehlschrank\w*|naehmaschine\w*|dunstabzug\w*|mikrowelle\w*/ },
    { key: 'signal', muster: /signallampe\w*|signalleucht\w*|\bsignal\b/ }
  ];

  function spezialKeys(text) {
    /* "UV-Block" ist ein UV-SCHUTZFILTER im Titel klassischer HID-Lampen
       (CDM-T/TC/TD "… G12 UV-Block") — das GEGENTEIL einer UV-Anwendung.
       Ohne diesen Ausschluss traf der bare-"uv"-Zweig des Musters auch
       "uv-block", stufte damit saemtliche UV-Block-Varianten als Spezial-
       anwendung ein und schob sie hinter jede Variante ohne den Zusatz —
       belegt am 13.08.2026 ("cdm-t": Bestseller-Raenge 64/125/279/326 erst
       ab Position 10, Chris-Befund). Beidseitig gestrippt (Query wie Titel),
       denn der Zusatz sagt in beiden Richtungen nichts ueber eine
       UV-Anwendung aus. */
    var t = String(text || '').replace(/\buv[- ]?block\w*/g, ' ');
    var out = [];
    for (var i = 0; i < SPEZIAL.length; i++) {
      if (SPEZIAL[i].muster.test(t)) out.push(SPEZIAL[i].key);
    }
    return out;
  }

  function anwendungStufe(analyse, p, idx) {
    var pKeys = spezialKeys(idx.norm);
    var pSpeziell = pKeys.length > 0 || typKanon(p && p.typ) === 'speziallampen';
    if (analyse.spezial && analyse.spezial.length) {
      for (var i = 0; i < analyse.spezial.length; i++) {
        if (pKeys.indexOf(analyse.spezial[i]) !== -1) return 0;
      }
      return 1;
    }
    return pSpeziell ? 1 : 0;
  }

  /* Nur eine ausdrueckliche LED-Anfrage darf ein Nicht-LED-Produkt abwerten.
     Umgekehrt wird NICHT abgewertet — das erledigt bei Roehren die Familie. */
  function technologieStufe(analyse, p, idx) {
    if (analyse.technologie !== 'led') return 0;
    if (typKanon(p && p.typ).indexOf('led') !== -1) return 0;
    return /\bled\b/.test(idx.norm) ? 0 : 1;
  }

  /* ================================================================ Query-Analyse */
  function analyze(query) {
    var roh = String(query == null ? '' : query);
    var norm = normalize(roh);
    var alle = tokens(roh);
    var kern = wesentlich(alle);
    var marke = erkenneMarke(norm);
    var serien = erkenneSerien(norm);
    var ident = identifierQuery(roh);
    var tech = null;
    try {
      tech = window.LMMTechRank ? window.LMMTechRank.parse(roh) : null;
    } catch (fehler) { tech = null; }
    /* Strukturiert = mindestens EIN erkannter technischer Wert. Bewusst
       schwaecher als tech.technisch (>= 2 Werte): jenes steuert die
       Kandidaten-VERENGUNG, dieses hier nur die REIHENFOLGE. Eine Anfrage
       wie "18W" darf sortiert, aber nicht verengt werden. */
    var strukturiert = !!(tech && (tech.watt !== null || tech.farbcode || tech.sockel || tech.laenge
      || (tech.beam !== null && tech.beam !== undefined)));
    var technologie = ident ? null : technologieVonQuery(norm);
    var familie = ident ? null : familieVonQuery(kern, norm);
    /* Bei erkannter Familie tragen die Familien- und Technologiewoerter selbst
       keine Unterscheidungskraft mehr — sie sind bereits durch die Familie
       abgebildet. Wuerden sie in der Titeldeckung bleiben, entschiede die
       SCHREIBWEISE ueber die Rangklasse: "Modee SMD LED A-Serie Roehre" deckt
       bei "LED Roehre" beide Suchwoerter (Klasse 1), bei "LED Leuchtroehre"
       dagegen nur ueber ein Synonym (Klasse 4) — und damit hatten die vier
       gleichbedeutenden Anfragen unterschiedliche Spitzenprodukte. */
    var rest = kern;
    if (familie) {
      rest = kern.filter(function (t) {
        if (ROEHREN_BEGRIFF[t]) return false;
        if (t === 'led' && familie.technologie === 'led') return false;
        return true;
      });
    }
    var analyse = {
      roh: roh,
      norm: norm,
      tokens: kern,
      alleTokens: alle,
      marke: marke,
      serien: serien,
      identifier: ident,
      tech: tech,
      dimmbar: /\b(?:nicht|non|ohne)\s+dimm(?:bar|able)\b/.test(norm) ? 'false' : (/\bdimm(?:bar|able|en)\b/.test(norm) ? 'true' : null),
      technologie: technologie,
      familie: familie,
      familieKey: familie ? familie.key : null,
      restTokens: rest,
      strukturiert: strukturiert && !ident,
      leer: kern.length === 0,
      /* Korrekturrunde 3: Spezialanwendungs- und Produktgruppen-Intent. */
      spezial: ident ? [] : spezialKeys(norm),
      gruppe: null,
      /* Query-seitige Zuordnung Token -> strukturiertes Merkmal (2026-08-11).
         Einmal je Anfrage, nicht je Produkt. */
      strukturTokens: null
    };
    if (!ident) analyse.gruppe = bucketIntent(analyse);
    if (!ident) analyse.strukturTokens = strukturKandidaten(analyse);
    return analyse;
  }

  /* ============================================================ Produkt-Auswertung */
  /* p = { titel, vendor, sku, ean, typ, watt, ersatzWatt, sockel, farbcode,
           kelvin, lumen, lichtfarbe, laenge, beam, cri, kaufbar, bewertung,
           bewertungen, bestRang, zusatzText }
     beam = specs.beam_angle · cri = specs.cri (Rohtext, auch ">80"/"≥ 90"). */
  function titelIndex(titel) {
    var norm = normalize(titel);
    var liste = tokens(titel);
    var menge = objekt(null);
    liste.forEach(function (t) { menge[t] = 1; });
    return { norm: norm, tokens: liste, menge: menge };
  }

  /* Kuratierte Serien-Aliasse fuer die Titeldeckung (Korrekturrunde 3, Chris
     Phase 6): Das Suchwort "tl" MUSS die zusammengezogenen Philips-Schreib-
     weisen "tld"/"tl5" treffen — sonst erreicht "Philips TUV TL Mini" volle
     Titeldeckung, waehrend jede TL-D-Roehre durchfaellt, und die Speziallampe
     steht per Klasse vor der Standardroehre. Analog "pl" fuer PL-S/PL-L/PL-C.
     Nur diese beiden kuratierten Nomenklaturen — keine allgemeine Praefixsuche. */
  var TOKEN_ALIAS = objekt({
    'kaltweiss': /\b(?:4000\s*k|840|kaltweiss|neutralweiss|cool\s*white)\b/,
    'tl': /(?:^|[^a-z0-9])tl[d5]?(?:$|[^0-9])/,
    'pl': /(?:^|[^a-z0-9])pl[lcst]?(?:$|[^0-9])/,
    /* "cdm" als GANZE Nomenklatur (2026-08-13): die CDM-Zusammenziehung oben
       macht aus jedem Titel "cdmt"/"cdmtc"/… — das blosse Suchwort "cdm"
       muss diese Familien weiterhin alle treffen. */
    'cdm': /(?:^|[^a-z0-9])cdm(?:r111|tc|td|tm|tw|t|r)?(?:$|[^0-9])/,
    /* Exact-Family-Grenze (2026-08-13, Chris Phase 14): die zusammengezogenen
       Familientokens vergleichen BEIDSEITIG mit strikter Wortgrenze — der
       generische Fallback unten erlaubt Buchstaben rechts ("g13" in "t8g13")
       und liesse damit "cdmt" faelschlich in "cdmtc" treffen. */
    'cdmt': /(?:^|[^a-z0-9])cdmt(?:$|[^a-z0-9])/,
    'cdmtc': /(?:^|[^a-z0-9])cdmtc(?:$|[^a-z0-9])/,
    'cdmtd': /(?:^|[^a-z0-9])cdmtd(?:$|[^a-z0-9])/,
    'cdmtm': /(?:^|[^a-z0-9])cdmtm(?:$|[^a-z0-9])/,
    'cdmr': /(?:^|[^a-z0-9])cdmr(?:$|[^a-z0-9])/,
    'cdmr111': /(?:^|[^a-z0-9])cdmr111(?:$|[^a-z0-9])/
  });

  function tokenImTitel(idx, t) {
    if (t === 'dimmbar' && /\b(?:nicht|non|ohne)\s+dimm(?:bar|able)\b/.test(idx.norm)) return false;
    if (idx.menge[t]) return true;
    var alias = TOKEN_ALIAS[t];
    if (alias) return alias.test(idx.norm);
    /* Zusammengeschriebene Varianten: "11w" in "7-16w" darf NICHT treffen,
       "g13" in "t8g13" schon. Deshalb Wortgrenze links, Ziffernstopp rechts. */
    if (t.length < 3) return false;
    var esc = t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('(?:^|[^a-z0-9])' + esc + '(?:$|[^0-9])').test(idx.norm);
  }

  /* 'erfuellt' (2026-08-11) ist die Menge der Query-Tokens, deren Bedeutung ein
     STAERKERER strukturierter Rangschluessel fuer genau dieses Produkt bereits
     exakt geklaert hat — siehe strukturellErfuellteTokens(). Sie zaehlen als
     gedeckt, unabhaengig von der Schreibweise des Lieferantentitels. Die Liste
     der Suchwoerter bleibt vollstaendig: was NICHT strukturiert geklaert ist,
     muss weiterhin im Titel stehen. */
  function deckung(tokenListe, idx, erfuellt) {
    var n = tokenListe.length;
    if (!n) return { anteil: 0, treffer: 0, gesamt: 0, voll: false, strukturell: 0 };
    var treffer = 0, strukturell = 0;
    tokenListe.forEach(function (t) {
      if (tokenImTitel(idx, t)) { treffer += 1; return; }
      if (erfuellt && erfuellt[t]) { treffer += 1; strukturell += 1; }
    });
    return {
      anteil: treffer / n, treffer: treffer, gesamt: n,
      voll: treffer === n, strukturell: strukturell
    };
  }

  function deckungMitSynonym(tokenListe, idx, erfuellt) {
    var n = tokenListe.length;
    if (!n) return 0;
    var punkte = 0;
    tokenListe.forEach(function (t) {
      if (tokenImTitel(idx, t) || (erfuellt && erfuellt[t])) { punkte += 1; return; }
      var syn = synonymeFuer(t);
      if (!syn) return;
      for (var i = 0; i < syn.length; i++) {
        if (tokenImTitel(idx, syn[i])) { punkte += 0.6; return; }
      }
    });
    return punkte / n;
  }

  /* Zusammenhaengende Originalphrase: mindestens zwei aufeinanderfolgende
     Query-Tokens stehen im Titel unmittelbar nebeneinander. */
  function phraseVorhanden(tokenListe, idx) {
    var t = tokenListe;
    if (t.length < 2) return false;
    for (var i = 0; i + 1 < t.length; i++) {
      var esc = [t[i], t[i + 1]].map(function (x) {
        return x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      });
      if (new RegExp('(?:^|[^a-z0-9])' + esc[0] + '[\\s\\-\\/]*' + esc[1] + '(?:$|[^0-9])').test(idx.norm)) return true;
    }
    return false;
  }

  function markeTrifft(analyse, p, idx) {
    if (!analyse.marke) return true;
    var text = grundNorm((p && p.vendor) || '') + ' ' + idx.norm;
    return analyse.marke.werte.some(function (w) { return text.indexOf(w) !== -1; });
  }

  function serienTrifft(analyse, idx) {
    if (!analyse.serien.length) return true;
    for (var i = 0; i < analyse.serien.length; i++) {
      if (!analyse.serien[i].muster.test(idx.norm)) return false;
    }
    return true;
  }

  /* Klasse 0: exakter Identifikator. Reihenfolge SKU -> Barcode/GTIN -> MPN ->
     Alias -> Altnummer. Erster Treffer gewinnt; es gibt keine Naeherung. */
  function identifierTreffer(analyse, p) {
    if (!analyse.identifier) return null;
    var q = analyse.identifier;
    if (identGleich(p && p.sku, q)) return 'sku';
    if (gtinGleich(p && p.ean, q)) return 'ean';
    if (identGleich(p && p.ean, q)) return 'barcode';
    if (identGleich(p && p.mpn, q)) return 'mpn';
    var alias = String((p && p.alias) || '');
    if (alias) {
      var gefunden = alias.split(/[,;|\s]+/).some(function (a) { return identGleich(a, q); });
      if (gefunden) return 'alias';
    }
    return null;
  }

  var KLASSE = {
    identifier: 0,
    titelVoll: 1,
    technikExakt: 2,
    markeSerie: 3,
    titelTeil: 4,
    strukturdaten: 5,
    sonstiges: 6,
    /* Harter Widerspruch zu einer ausdruecklichen Query-Bedingung
       (Korrekturrunde 4): kein regulaerer Treffer. Beide Oberflaechen
       schliessen diese Klasse aus der regulaeren Produktliste aus. */
    widerspruch: 9
  };

  /* ================== Harte Query-Bedingungen (Korrekturrunde 4) ============
     Liefert die Liste der strukturiert WIDERSPRECHENDEN Merkmale. Ein leeres
     Ergebnis heisst: exakt ODER unbekannt — fehlende Daten sind eine
     Datenluecke, kein Widerspruch. Quelle je Merkmal:
       sockel        specs.base (fuehrend), Titel nur bei fehlendem Feld
       gruppe        gepflegter Produkttyp / Suchseiten-Bucket / Titelmarker
       ersatzleistung specs.replaces_wattage bei ausdruecklicher Ersatzabsicht
       watt          specs.wattage + specs.replaces_wattage (nur enge Query)
       kelvin        specs.kelvin bzw. verifizierter Farbcode (kelvinAusCode)
       farbcode      specs.color_code; bei 9xx-Anfrage ohne color_code
                     zusaetzlich specs.cri (nur eindeutig numerisch < 90)
       beam          specs.beam_angle (exakt vor unbekannt vor Widerspruch)
       laenge        specs.length */
  /* ============================================== TITLE-FIRST (Chris 13.08.2026)
     Loest die technischen Merkmale EINES Produkts merkmalsweise auf: steht der Wert
     eindeutig im Artikelnamen, gilt der Titelwert; sonst das strukturierte Feld.
     Zurueckgegeben wird eine KOPIE des Produktobjekts — alle uebrigen Felder (Typ,
     Vendor, SKU, Verfuegbarkeit, Bestseller-Rang, Zusatztext) bleiben unveraendert,
     und die Produktdaten im Shop werden nicht angefasst.

     Warum als Kopie und nicht als Umbau jeder Stufenfunktion: wattStufe, kelvinStufe,
     lumenStufe, sockelStufe, harteBedingungen, strukturellErfuellteTokens und
     LMMTechRank.classify lesen alle dieselben Feldnamen. Wird die Aufloesung EINMAL
     am Eingang von rank() vorgenommen, gilt TITLE-FIRST fuer die gesamte Kaskade —
     statt an einem Dutzend Stellen unterschiedlich nachgebaut zu werden.

     Konflikte werden NICHT korrigiert, sondern nur gezaehlt (window.LMMRelevance.
     konflikte()) — ein abweichendes Metafeld kann eine echte Betriebs- oder
     Systemleistung sein und ist kein Datenfehler. */
  var TF_TOLERANZ = { watt: 0.6, ersatzWatt: 0.6, kelvin: 60, lumen: 0, laenge: 6, beam: 0.5, cri: 0.5 };
  var TF_FELDER = ['watt', 'ersatzWatt', 'farbcode', 'kelvin', 'lumen', 'laenge', 'beam', 'cri', 'sockel'];
  var tfKonflikte = [];

  function merkmaleAufloesen(p, idx) {
    if (!p || p.__titleFirst) return p;
    var T = window.LMMTechRank;
    if (!T || typeof T.titelMerkmale !== 'function') return p;
    var tm;
    try { tm = T.titelMerkmale((p && p.titel) || (idx && idx.norm) || ''); }
    catch (fehler) { return p; }
    var out = {};
    for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) out[k] = p[k]; }
    for (var i = 0; i < TF_FELDER.length; i++) {
      var feld = TF_FELDER[i];
      var r = T.resolveMerkmal(tm[feld], p[feld], TF_TOLERANZ[feld] || 0);
      out[feld] = r.wert;
      if (r.konflikt && tfKonflikte.length < 500) {
        tfKonflikte.push({ titel: (p.titel || '').slice(0, 90), merkmal: feld,
                           titelwert: tm[feld], metafeld: p[feld] });
      }
    }
    out.__titleFirst = true;
    out.__titelMerkmale = tm;
    return out;
  }

  function harteBedingungen(analyse, p, idx, kelvinS) {
    p = merkmaleAufloesen(p, idx);
    var gruende = [];
    var nichtDimmbar = /\b(?:nicht|non|ohne)\s+dimm(?:bar|able)\b/.test(idx.norm);
    if (analyse.dimmbar === 'true' && nichtDimmbar) gruende.push('dimmbar');
    if (analyse.dimmbar === 'false' && /\bdimm(?:bar|able)\b/.test(idx.norm) && !nichtDimmbar) gruende.push('dimmbar');
    var T = window.LMMTechRank;
    var tech = analyse.tech;
    /* Sockel: exakt normalisiert, exakt verglichen. G9 ist nicht GU5.3. */
    if (tech && tech.sockel && T && T.sockelImText) {
      var base = p && p.sockel ? String(p.sockel) : '';
      if (base) {
        if (!T.sockelImText(tech.sockel, base)) gruende.push('sockel');
      } else if (!T.sockelImText(tech.sockel, idx.norm)) {
        var anderer = T.findeSockel(idx.norm, true);
        if (anderer && anderer !== T.kanonSockel(tech.sockel)) gruende.push('sockel');
      }
    }
    /* Produktgruppe: nur eine AUSDRUECKLICH genannte Gruppe prueft hart, und
       nur gegen einen BELEGTEN Produkt-Bucket ("Leuchtmittel gesucht, Produkt
       ist Leuchte"). Unbekannte Buckets bleiben regulaere Kandidaten. */
    if (analyse.gruppe && analyse.gruppe.modus === 'explizit') {
      var b = bucketBekannt(p, idx);
      /* SOFTENING (Korrekturrunde 4): Traegt der PRODUKTTITEL selbst die
         Woerter der gesuchten Gruppe, ist der gepflegte Typ kein belastbarer
         Widerspruch — belegt am "Philips Starter S2" (Typ faelschlich
         "Leuchtstoffroehren") und am "Osram Vorschaltgeraet QT-FIT" (Typ
         faelschlich "Leuchtstoffroehren"): das gesuchte Produkt selbst
         waere sonst ausgeschlossen worden. */
      /* TITLE-FIRST (2026-08-13, Teil 21): Ausgeschlossen wird nur, wenn KEINE
         Quelle die gesuchte Gruppe belegt — weder der Titel noch der gepflegte
         Produkttyp noch das gepflegte custom.product_kind. Vorher zaehlte hier
         allein der Titelmarker; echte Starter ohne das Wort "Starter" im Titel
         (Radium RS 51/RS 11, Philips BodyTone St) flogen dadurch aus dem
         Starter-Intent, obwohl product_kind = "starter" gepflegt ist. Genau der
         Fall, fuer den die Rueckfallebene gedacht ist: Titel schweigt -> Feld
         entscheidet. Dieselbe Evidenzpruefung wie in bucketStufe, damit harte
         und weiche Stufe nicht wieder auseinanderlaufen. */
      if (b && b !== analyse.gruppe.key && !gruppeBelegt(p, idx, analyse.gruppe.key)) {
        gruende.push('gruppe');
      }
    }
    /* Leistung. Bei ausdruecklicher Ersatzabsicht zaehlt AUSSCHLIESSLICH die
       verifizierte Ersatzleistung (Chris Phase 8: Eigenleistung 6 W mit
       "ersetzt 42 W" ist kein Ersatz fuer 6 W; eine unverifizierte
       Titelbeziehung ebenso wenig, Chris Phase 9). Bei einer engen direkten
       Anfrage ("g 9 2,9 w") widerspricht ein Produkt ohne jede belegte
       Beziehung zur gesuchten Leistung. */
    var qw = tech && tech.watt !== null && tech.watt !== undefined ? Number(tech.watt) : NaN;
    if (isFinite(qw)) {
      var pw = zahlOderNaN(p && p.watt);
      var pr = zahlOderNaN(p && p.ersatzWatt);
      var direkt = isFinite(pw) && Math.abs(pw - qw) < 0.05;
      var ersatz = ersatzTrifft(analyse, pr, qw);
      if (tech.ersatzAbsichtStark) {
        if (!ersatz) gruende.push('ersatzleistung');
      } else if (tech.technisch && !direkt && !ersatz) {
        /* WIDERSPRUCH nur mit Beleg: entweder ein bekanntes, abweichendes
           Wattmetafeld — oder (bei fehlendem Metafeld) ein Titel, der
           ausdrueckliche Wattwerte nennt, aber keinen davon in der gesuchten
           Stufe (bewaehrte Regel titelWattWiderspruch). Fehlt beides, ist die
           Leistung UNBEKANNT: Datenluecke, kein Ausschluss (Phase 3). */
        if (isFinite(pw)) {
          gruende.push('watt');
        } else if (T && T.titelWerte && T.titelWattWiderspruch
                   && T.titelWattWiderspruch(T.titelWerte((p && p.titel) || ''), qw)) {
          gruende.push('watt');
        }
      }
    }
    if (kelvinS === 2) gruende.push('kelvin');
    if (tech && tech.farbcode && p && p.farbcode) {
      var pf = String(p.farbcode).trim();
      if (pf && pf !== String(tech.farbcode)) gruende.push('farbcode');
    } else if (tech && tech.farbcode && /^9/.test(String(tech.farbcode)) && p && !p.farbcode) {
      /* 9xx-Farbcode ohne gepflegten specs.color_code (Chris Phase 10,
         2026-08-13): die erste Ziffer ist das Farbwiedergabe-Band. Ein Produkt
         mit EINDEUTIG numerischem CRI unter 90 ("80", "85") widerspricht einer
         927/930/940-Anfrage. Relationale Rohwerte (">80", "≥ 80") beweisen
         kein Band und bleiben eine Datenluecke — kein Ausschluss. Der
         Kelvin-Anteil des Codes laeuft weiter ueber kelvinStufe/kelvinAusCode. */
      var criRoh = String((p && p.cri) || '').trim();
      if (/^\d{2,3}$/.test(criRoh) && Number(criRoh) < 90) gruende.push('farbcode');
    }
    /* Abstrahlwinkel (Chris Phase 11, 2026-08-13; Kollegen-Fall "GU10 50W 927
       120°"): specs.beam_angle ist derselbe Wert wie im Collection-Filter.
       Exakt vor unbekannt vor Widerspruch — ein belegter 36°-Spot ist bei
       einer ausdruecklichen 120°-Anfrage kein regulaerer Treffer. */
    if (tech && tech.beam !== null && tech.beam !== undefined) {
      var pbeam = zahlOderNaN(p && p.beam);
      if (isFinite(pbeam) && Math.abs(pbeam - Number(tech.beam)) > 0.5) gruende.push('beam');
    }
    if (tech && tech.laenge) {
      var plaenge = zahlOderNaN(p && p.laenge);
      var qlaenge = Number(tech.laenge);
      if (isFinite(plaenge) && isFinite(qlaenge)
          && Math.abs(plaenge - qlaenge) > Math.max(qlaenge * 0.02, 6)) {
        gruende.push('laenge');
      }
    }
    return gruende;
  }

  /* Sockel als eigener Rangschluessel (EXAKT vor UNBEKANNT; WIDERSPRUCH ist
     bereits KLASSE.widerspruch): 0 = exakt belegt, 1 = unbekannt. */
  function sockelStufe(analyse, p, idx) {
    var T = window.LMMTechRank;
    var s = analyse.tech && (analyse.tech.sockel || analyse.tech.sockelFallback);
    if (!s || !T || !T.sockelImText) return 0;
    var base = p && p.sockel ? String(p.sockel) : '';
    if (base) return T.sockelImText(s, base) ? 0 : 1;
    return T.sockelImText(s, idx.norm) ? 0 : 1;
  }

  /* ========= Strukturell bereits erfuellte Query-Tokens (Chris 2026-08-11) ==
     Ein Query-Merkmal, das ein STAERKERER strukturierter Rangschluessel fuer
     genau dieses Produkt bereits EXAKT geklaert hat, darf nicht ein zweites Mal
     als fehlendes Titelwort bestraft werden. Sonst entscheidet die
     Lieferanten-Schreibweise ueber die Reihenfolge.

     BELEGT am 11.08.2026 fuer "18W Leuchtstoffroehre durch LED ersetzen":
     alle 90 Kandidaten tragen verifiziert specs.replaces_wattage = 18 und
     erhalten dadurch wattstufe 0, technik 1 und Klasse 2 — die 18 W sind also
     strukturiert exakt erfuellt. Trotzdem bekamen nur Titel mit der
     Schreibweise "10-18W"/"8-18W" den Deckungswert 667, die inhaltlich
     gleichwertigen "8W/865" und "8W/840" dagegen 1000. Weil 'fehl' VOR den
     Weichfaktoren (seit 2026-08-13: Bestseller-Rang) steht, stand das
     Produkt SKU 1030000057 (Bestseller-Rang 550) auf Platz 66
     von 71. Gemessen: 86 der 90 Titel enthalten "18w", 4 nicht — ueber die
     Reihenfolge entschied die Schreibweise, nicht die Eignung.

     BELEG ist ausschliesslich das strukturierte Feld beziehungsweise der
     Rangschluessel, der es auswertet — niemals der Produkttitel:
       watt      wattStufe()   === 0  (specs.wattage bzw. bei belegter
                                       Ersatzabsicht specs.replaces_wattage)
       kelvin    kelvinStufe() === 0  (specs.kelvin oder verifizierter Farbcode)
       lumen     lumenStufe()  === 0  (specs.lumen)
       sockel    specs.base       vorhanden UND exakt
       farbcode  specs.color_code vorhanden UND exakt
       laenge    specs.length     vorhanden UND in derselben Toleranz wie die
                 harte Bedingung
       marke     das vendor-FELD traegt die Marke (der Schluessel 'marke' steht
                 vor 'fehl' und bewertet sie bereits vollstaendig)
       ersatz    Absichtswort, dessen Bedeutung die Ersatz-Leseart vollstaendig
                 aufgenommen hat. EINZIGE Quelle ist LMMTechRank.parse —
                 hier entsteht bewusst KEINE zweite Wortliste.

     Fehlt das Feld oder weicht es ab, bleibt das Token ein normales Suchwort,
     das weiterhin im Titel stehen muss. Dadurch kann diese Regel nur GLEICH
     geeignete Treffer gleichstellen, niemals einen Nichttreffer nach vorn
     holen — und die Titelrelevanz bleibt fuer alles erhalten, was NICHT
     strukturiert geklaert ist (Serien wie TUV/Puritec/Master, Formen,
     freie Bezeichnungen). Familien- und Technologiewoerter werden hier NICHT
     angefasst: die entfernt analyze() bereits ueber restTokens mit eigener
     Begruendung, und das Familien-Gate bleibt unveraendert. */
  var RE_TOK_WATT = /^(\d{1,3}(?:\.\d+)?)w$/;
  var RE_TOK_KELVIN = /^(\d{3,5})k$/;
  var RE_TOK_LUMEN = /^(\d{2,6})lm$/;
  var RE_TOK_LAENGE = /^(\d{2,5})mm$/;
  var RE_TOK_CODE = /^\d{3}$/;

  function nahe(a, b, tol) {
    return isFinite(a) && isFinite(b) && Math.abs(a - b) < tol;
  }

  /* Einmal je ANFRAGE: welches Token traegt welches strukturierte Merkmal?
     Rein query-seitig — ob es ERFUELLT ist, entscheidet erst das Produkt. */
  function strukturKandidaten(analyse) {
    var tech = analyse.tech;
    var T = window.LMMTechRank;
    var liste = (analyse.familie && analyse.restTokens) ? analyse.restTokens : analyse.tokens;
    var out = [];
    liste.forEach(function (t) {
      var m;
      if (tech && tech.watt !== null && tech.watt !== undefined
          && (m = RE_TOK_WATT.exec(t)) && nahe(Number(m[1]), Number(tech.watt), 0.05)) {
        out.push({ t: t, art: 'watt' }); return;
      }
      if (tech && tech.kelvin !== null && tech.kelvin !== undefined
          && (m = RE_TOK_KELVIN.exec(t)) && nahe(Number(m[1]), Number(tech.kelvin), 51)) {
        out.push({ t: t, art: 'kelvin' }); return;
      }
      if (tech && tech.lumen !== null && tech.lumen !== undefined
          && (m = RE_TOK_LUMEN.exec(t)) && nahe(Number(m[1]), Number(tech.lumen), 1)) {
        out.push({ t: t, art: 'lumen' }); return;
      }
      if (tech && tech.laenge !== null && tech.laenge !== undefined
          && (m = RE_TOK_LAENGE.exec(t)) && nahe(Number(m[1]), Number(tech.laenge), 1)) {
        out.push({ t: t, art: 'laenge' }); return;
      }
      if (tech && tech.farbcode && RE_TOK_CODE.test(t) && t === String(tech.farbcode)) {
        out.push({ t: t, art: 'farbcode' }); return;
      }
      /* "120°" wird zum Token "120" (das Gradzeichen ist Trennzeichen) —
         strukturiert erfuellt es specs.beam_angle (2026-08-13). */
      if (tech && tech.beam !== null && tech.beam !== undefined
          && /^\d{1,3}$/.test(t) && Number(t) === Number(tech.beam)) {
        out.push({ t: t, art: 'beam' }); return;
      }
      if (tech && tech.sockel && T && T.kanonSockel
          && T.kanonSockel(t) === T.kanonSockel(tech.sockel)) {
        out.push({ t: t, art: 'sockel' }); return;
      }
      if (analyse.marke && analyse.marke.werte.indexOf(t) !== -1) {
        out.push({ t: t, art: 'marke' }); return;
      }
      if (tech && tech.ersatzPrimaer && T && T.parse) {
        var eig = null;
        try { eig = T.parse(t); } catch (fehler) { eig = null; }
        if (eig && eig.ersatzAbsichtStark) { out.push({ t: t, art: 'ersatz' }); return; }
      }
    });
    return out;
  }

  /* Produktseitige Pruefung. Liefert eine Token-Menge oder null. */
  function strukturellErfuellteTokens(analyse, p) {
    var kand = analyse.strukturTokens;
    if (!kand || !kand.length) return null;
    var tech = analyse.tech;
    var T = window.LMMTechRank;
    var out = null;
    for (var i = 0; i < kand.length; i++) {
      var art = kand[i].art, ok = false;
      if (art === 'watt') {
        /* Stufe 0 (Eigenleistung exakt) ODER Stufe 1 (verifizierter Ersatz,
           inkl. Ersatzklasse ausserhalb des Roehrenkontexts) — beide sind
           strukturiert belegt (2026-08-13, Chris Phase 12: die Kernmenge der
           50-W-Klasse darf nicht an der Titelschreibweise "51W" zerfallen). */
        ok = wattStufe(analyse, p) <= 1;
      } else if (art === 'beam') {
        var pbe = zahlOderNaN(p && p.beam), qbe = Number(tech.beam);
        ok = isFinite(pbe) && isFinite(qbe) && Math.abs(pbe - qbe) <= 0.5;
      } else if (art === 'kelvin') {
        ok = kelvinStufe(analyse, p) === 0;
      } else if (art === 'lumen') {
        ok = lumenStufe(analyse, p) === 0;
      } else if (art === 'sockel') {
        ok = !!(p && p.sockel) && !!(T && T.sockelImText)
          && T.sockelImText(tech.sockel, String(p.sockel));
      } else if (art === 'farbcode') {
        ok = !!(p && p.farbcode) && String(p.farbcode).trim() === String(tech.farbcode);
        /* 9xx ohne gepflegten Farbcode (Chris Phase 10): die Kombination aus
           passendem Kelvinwert (letzte zwei Ziffern x 100) und belegtem
           CRI >= 90 erfuellt den Code strukturiert — nur belegte Daten,
           nichts wird aus Luecken erfunden. "≥ 90"/"90"/"95" zaehlen,
           ">80" beweist kein 90er-Band. */
        if (!ok && /^9/.test(String(tech.farbcode)) && p && !p.farbcode
            && T && typeof T.kelvinAusCode === 'function') {
          var zielK = Number(T.kelvinAusCode(String(tech.farbcode)));
          var pK = zahlOderNaN(p.kelvin);
          var criM = /(\d{2,3})/.exec(String((p && p.cri) || ''));
          ok = isFinite(zielK) && isFinite(pK) && Math.abs(pK - zielK) < 51
            && !!criM && Number(criM[1]) >= 90;
        }
      } else if (art === 'laenge') {
        var pl = zahlOderNaN(p && p.laenge), ql = Number(tech.laenge);
        ok = isFinite(pl) && isFinite(ql) && Math.abs(pl - ql) <= Math.max(ql * 0.02, 6);
      } else if (art === 'marke') {
        var vend = grundNorm((p && p.vendor) || '');
        ok = !!vend && analyse.marke.werte.some(function (w) { return vend.indexOf(w) !== -1; });
      } else if (art === 'ersatz') {
        /* Query-seitig: die Absicht gilt fuer die ganze Anfrage, nicht je Produkt. */
        ok = true;
      }
      if (ok) {
        if (!out) out = objekt(null);
        out[kand[i].t] = 1;
      }
    }
    return out;
  }

  /* Liefert den vollstaendigen Rangvektor. Kleinere Werte sind besser.
     Jede Komponente ist im DOM als data-lmm-r* nachvollziehbar. */
  function rank(analyse, p) {
    var idx = titelIndex((p && p.titel) || '');
    /* TITLE-FIRST: EIN Aufloesungspunkt fuer die gesamte Kaskade. Ab hier tragen
       p.watt/ersatzWatt/farbcode/kelvin/lumen/laenge/beam/cri/sockel den Titelwert,
       wo der Titel eindeutig ist — sonst unveraendert den Metafeldwert. */
    p = merkmaleAufloesen(p, idx);
    var v = {
      klasse: KLASSE.sonstiges,
      grund: 'kein-treffer',
      wattstufe: 0,        /* neutral, wenn keine Leistung gesucht ist */
      kelvin: 0,           /* neutral, wenn kein Kelvinwert gesucht ist */
      lumen: 0,            /* neutral, wenn kein Lichtstrom gesucht ist */
      sockel: 0,           /* 0 exakt/kein Sockel gesucht · 1 unbekannt (K4) */
      hart: 0,             /* Anzahl harter Widersprueche (Korrekturrunde 4) */
      hartGrund: '',
      technik: 3,          /* neutral, wenn keine technischen Werte gesucht sind */
      technologie: 0,
      bucket: 0,           /* Produktgruppe (Korrekturrunde 3, Phase 3) */
      familie: 0,
      marke: 0,
      serie: 0,
      anwendung: 0,        /* Standard- vor Spezialanwendung (Phase 6) */
      fehl: 1000,          /* 1000 * (1 - Deckung) */
      phrase: 1,
      struktur: 1,
      kaufbar: 1,
      bewertung: 999,
      bewertungen: 0,
      best: 999999999
    };

    /* Technologie, Familie, Leistungs-, Kelvin-, Gruppen- und Anwendungsbezug
       gelten fuer jedes Produkt dieser Anfrage — vor der Klassenbildung. */
    v.wattstufe = wattStufe(analyse, p);
    v.kelvin = kelvinStufe(analyse, p);
    v.lumen = lumenStufe(analyse, p);
    v.sockel = sockelStufe(analyse, p, idx);
    v.technologie = technologieStufe(analyse, p, idx);
    v.bucket = bucketStufe(analyse, p, idx);
    v.anwendung = anwendungStufe(analyse, p, idx);
    v.familie = analyse.familie ? familieTrifft(analyse.familie, p, idx) : 0;

    var id = identifierTreffer(analyse, p);
    if (id) {
      v.klasse = KLASSE.identifier;
      v.grund = 'identifier-' + id;
      v.fehl = 0; v.phrase = 0; v.struktur = 0; v.technik = 0;
      v.wattstufe = 0; v.technologie = 0; v.familie = 0;
      v.kelvin = 0; v.lumen = 0; v.sockel = 0; v.bucket = 0; v.anwendung = 0;
      return abschluss(v, p);
    }
    /* Harte Query-Bedingungen (Korrekturrunde 4) — nach dem Identifier (ein
       exakter Feldtreffer ist immer ein Treffer), vor jeder weiteren Klasse. */
    if (!analyse.identifier) {
      var hartListe = harteBedingungen(analyse, p, idx, v.kelvin);
      v.hart = hartListe.length;
      v.hartGrund = hartListe.join('+');
    }
    /* Reine Identifier-Anfrage OHNE exakten Feldtreffer: das Produkt ist kein
       Treffer. Kein Fuzzy-Rang, keine Naeherung ueber aehnliche Nummern. */
    if (analyse.identifier) {
      v.klasse = KLASSE.sonstiges;
      v.grund = 'identifier-kein-exakter-treffer';
      return abschluss(v, p);
    }

    /* Technische Klasse aus der bestehenden Engine — dieselbe Quelle, die auch
       die Kandidatenstufe steuert. Sie laeuft ab EINEM erkannten Wert. */
    if (analyse.strukturiert && window.LMMTechRank && analyse.tech) {
      try {
        var k = window.LMMTechRank.classify(analyse.tech, p);
        v.technik = window.LMMTechRank.gewicht(analyse.tech, k.klasse);
        v.grund = k.grund;
      } catch (fehler) { v.technik = 3; }
    }

    /* Wirktokens: bei erkannter Familie ohne die Familien-/Technologiewoerter. */
    var wirk = (analyse.familie && analyse.restTokens) ? analyse.restTokens : analyse.tokens;
    /* Was ein staerkerer strukturierter Schluessel fuer GENAU DIESES Produkt
       schon exakt geklaert hat, zaehlt als gedeckt (2026-08-11). */
    var erfuellt = strukturellErfuellteTokens(analyse, p);
    var deck = deckung(wirk, idx, erfuellt);
    var mTrifft = markeTrifft(analyse, p, idx);
    var sTrifft = serienTrifft(analyse, idx);
    v.marke = mTrifft ? 0 : 1;
    v.serie = sTrifft ? 0 : 1;
    v.phrase = phraseVorhanden(wirk, idx) ? 0 : 1;

    /* Reine Familienanfrage ("LED Leuchtroehre", "LED Tube", …): es bleibt kein
       unterscheidendes Suchwort uebrig. Dann ist jedes Familienmitglied gleich
       gut getroffen; ueber die Reihenfolge entscheiden danach ausschliesslich
       Wattstufe, Technik, Verfuegbarkeit und Bewertung. */
    if (analyse.familie && wirk.length === 0) {
      if (v.familie <= 1) {
        v.klasse = KLASSE.titelVoll;
        v.grund = 'familie-' + analyse.familie.key;
        v.fehl = 0;
      } else {
        v.klasse = KLASSE.sonstiges;
        v.grund = 'familie-fremd';
        v.fehl = 1000;
      }
      return abschluss(v, p);
    }

    if (deck.voll && deck.gesamt > 0) {
      v.klasse = KLASSE.titelVoll;
      v.grund = deck.strukturell > 0 ? 'titel-voll-strukturiert' : 'titel-voll';
      v.fehl = 0;
    } else if (analyse.strukturiert && v.technik <= 2) {
      v.klasse = KLASSE.technikExakt;
      v.fehl = Math.round(1000 * (1 - deck.anteil));
    } else if (analyse.marke && mTrifft && analyse.serien.length && sTrifft) {
      v.klasse = KLASSE.markeSerie;
      v.grund = 'marke-serie';
      v.fehl = Math.round(1000 * (1 - deck.anteil));
    } else {
      var syn = deckungMitSynonym(wirk, idx, erfuellt);
      if (syn > 0) {
        v.klasse = KLASSE.titelTeil;
        v.grund = 'titel-teil';
        v.fehl = Math.round(1000 * (1 - syn));
      } else {
        var zusatz = grundNorm((p && p.zusatzText) || '');
        var strukturTreffer = wirk.some(function (t) { return zusatz.indexOf(t) !== -1; });
        v.klasse = strukturTreffer ? KLASSE.strukturdaten : KLASSE.sonstiges;
        v.grund = strukturTreffer ? 'strukturdaten' : 'kein-treffer';
        v.struktur = strukturTreffer ? 0 : 1;
        v.fehl = 1000;
      }
    }
    /* FAMILIEN-GATE (Chris Phase 3, negative Abgrenzung). Bei einer erkannten
       Roehrenanfrage ist ein Produkt ausserhalb der Familie kein fachlicher
       Treffer — unabhaengig davon, wie vollstaendig sein Titel die Suchwoerter
       enthaelt. Ohne dieses Gate stand bei "LED Roehre" ein Ledvance LED
       TREIBER (Produkttyp "Vorschaltgeraete/Treiber", Titel nennt LED-Roehren)
       mit voller Titeldeckung auf den Plaetzen 2 bis 5, und bei
       "LED Leuchtroehre" fuellten EVN-Leuchten die gesamte erste Seite.
       Die Klasse wird gesetzt, nicht der Kandidat entfernt: das Produkt bleibt
       auffindbar, steht aber hinter jedem echten Familienmitglied. */
    if (analyse.familie && v.familie === 2 && v.klasse < KLASSE.sonstiges) {
      v.klasse = KLASSE.sonstiges;
      v.grund = 'familie-fremd';
    }
    /* SOCKEL-GATE (Korrekturrunde 3, Phase 3): Eine reine Sockelanfrage
       bezeichnet ein LEUCHTMITTEL — dieselbe fachliche Regel wie classify-
       Ausschluss 2 (Chris 2026-07-30). Eine komplette Leuchte darf ihre volle
       Titeldeckung ("Wand-/Deckenleuchte … GU10 6,1W", belegt 04.08.2026 bei
       "6.1W GU10") nicht in Klasse 1 vor die Leuchtmittel tragen. Sie bleibt
       auffindbar (Klasse 4), nur eben hinter den Leuchtmitteln. Nennt die
       Query selbst eine Leuchte, greift das Gate nicht. */
    /* Seit 2026-08-14 gilt dasselbe Gate auch fuer LAMPEN-SPEC-Anfragen
       (modus 'spec': Watt + Farbcode/Kelvin) — "18W 830 led" meint ein
       Leuchtmittel; ein Downlight traegt seine woertliche Titeldeckung
       ("18W/830") sonst vor die fachlich richtigen Lampen. */
    if (analyse.gruppe
        && (analyse.gruppe.modus === 'sockel' || analyse.gruppe.modus === 'spec')
        && v.klasse < KLASSE.titelTeil
        && (!analyse.tech || !analyse.tech.leuchteGesucht)) {
      /* KORREKTURRUNDE 4: nicht nur Leuchten — auch Fassungen, Treiber und
         Zubehoer duerfen ihre Titeldeckung bei einer reinen Sockelanfrage
         nicht VOR die Leuchtmittel tragen. Innerhalb der Stufe ordnet der
         bucket-Schluessel: Leuchtmittel -> Leuchte -> Fassung -> Zubehoer. */
      var bGate = bucketVonProdukt(p, idx);
      if (bGate !== 'leuchtmittel') {
        v.klasse = KLASSE.titelTeil;
        v.grund = bGate + '-statt-leuchtmittel';
      }
    }
    return abschluss(v, p);
  }

  /* Verfuegbarkeit und Bestseller-Rang greifen ausschliesslich INNERHALB
     derselben Klasse (Chris Phase 7; Standardsortierung seit 2026-08-13:
     Bestseller ERSETZT Sterne/Bewertungsanzahl als Rangmerkmal). bewertung/
     bewertungen werden weiter berechnet — fuer den manuellen Suchseiten-Modus
     "Beste Bewertungen" und die data-lmm-r*-Debug-Attribute. */
  function abschluss(v, p) {
    /* Harter Widerspruch (Korrekturrunde 4): das Produkt ist kein regulaerer
       Treffer — unabhaengig von Titeldeckung, Bewertung oder Bestseller-Rang.
       Nur der exakte Identifikator (Klasse 0) bleibt davon unberuehrt. */
    if (v.hart > 0 && v.klasse !== KLASSE.identifier) {
      v.klasse = KLASSE.widerspruch;
      v.grund = 'hart-' + (v.hartGrund || 'widerspruch');
    }
    v.kaufbar = p && p.kaufbar ? 0 : 1;
    var note = p && p.bewertung !== undefined && p.bewertung !== null && p.bewertung !== ''
      ? Number(p.bewertung) : NaN;
    var anzahl = p && p.bewertungen !== undefined && p.bewertungen !== null && p.bewertungen !== ''
      ? Number(p.bewertungen) : NaN;
    if (isFinite(note) && isFinite(anzahl) && anzahl > 0) {
      /* Invertierte Ganzzahl (bessere Note = kleinerer Wert); seit 2026-08-13
         NICHT mehr Teil der Standard-SCHLUESSEL — nur "Beste Bewertungen". */
      v.bewertung = Math.round((5 - Math.min(note, 5)) * 100);
      v.bewertungen = anzahl;
    } else {
      v.bewertung = 999;
      v.bewertungen = 0;
    }
    var best = p && p.bestRang !== undefined && p.bestRang !== null ? Number(p.bestRang) : NaN;
    v.best = isFinite(best) ? best : 999999999;
    return v;
  }

  /* Reihenfolge der Schluessel — die verbindliche Rangfolge in einer Liste.
     STANDARDSORTIERUNG seit 2026-08-13 (Chris, Struktur-/Bestseller-Auftrag):
     Identifier · vollstaendige Titeldeckung · exakte technische Direktwerte
     (Watt, Kelvin, Lumen, Technikklasse) · exakte Technologie · Produktgruppe ·
     Marke · Serie · Anwendung · Produktfamilie · Teiltreffer · Strukturdaten ·
     Verfuegbarkeit · BESTSELLER-RANG · Stabilitaet (Serverreihenfolge).
     Sterne und Bewertungsanzahl sind KEIN Standardrangmerkmal mehr — ein
     fachlich passender Bestseller darf nicht hinter einem 5,0-Sterne-Produkt
     mit einer einzigen Bewertung stehen (Chris 2026-08-13). Die Werte bleiben
     im Vektor fuer den manuellen Modus "Beste Bewertungen" erhalten.
     "wattstufe" traegt die Direktuebereinstimmung UND den verifizierten Ersatz
     in einem Wert (0 direkt, 1 Ersatz, 2 falsche Ersatzklasse, 3 keine).
     Kein Bestsellerwert kann einen falschen Kelvin-, Watt-, Beam-, Gruppen-,
     Anwendungs-, Marken- oder Serienwert vor einen exakten Treffer setzen —
     alle harten Schluessel stehen VOR den Weichfaktoren (Chris Phase 15).
     "phrase" steht bewusst GANZ unten — siehe Kopfkommentar. */
  var SCHLUESSEL = [
    ['klasse', 1], ['wattstufe', 1], ['kelvin', 1], ['lumen', 1], ['sockel', 1],
    ['technik', 1], ['technologie', 1], ['bucket', 1],
    ['marke', 1], ['serie', 1], ['anwendung', 1], ['familie', 1],
    ['fehl', 1], ['struktur', 1],
    ['kaufbar', 1], ['best', 1],
    ['phrase', 1]
  ];

  function vergleiche(a, b) {
    for (var i = 0; i < SCHLUESSEL.length; i++) {
      var key = SCHLUESSEL[i][0], richtung = SCHLUESSEL[i][1];
      var av = Number(a[key]), bv = Number(b[key]);
      if (!isFinite(av)) av = 0;
      if (!isFinite(bv)) bv = 0;
      if (av !== bv) return richtung > 0 ? av - bv : bv - av;
    }
    return 0;
  }

  /* ============================== Routing-Entscheidung (Chris Phase 5) ======
     Eine automatische Weiterleitung auf eine Collection ist NUR bei einem
     reinen, breiten Kategorie-Intent zulaessig. Sobald die Anfrage ein
     konkretes Produktmerkmal nennt, bleibt der Kunde in der Produktsuche und
     die passende Kategorie erscheint nur noch als Empfehlung.

     Ausschlusskriterien (verbindliche Liste aus dem Auftrag):
       erkannte Marke · erkannte Serie · Artikelnummer · EAN/GTIN ·
       Herstellerartikelnummer · Watt · Kelvin · Farbcode · Lumen · Sockel ·
       Laenge · Spannung · Betriebsart · mehrere konkrete Produkttokens.

     Der Auftrag nennt daneben "GU10 Lampen", "R7s Halogenstaebe" und
     "WAGO Klemmen" als moegliche Kategorie-Intents — die enthalten aber
     Sockel beziehungsweise Marke und fallen damit unter die Ausschlussliste.
     Die Ausschlussliste hat hier Vorrang, weil sie als Regel formuliert ist
     und die Beispiele ausdruecklich nur "moegliche" Faelle nennen. Der Preis
     dafuer ist null: die nativen Treffer bleiben seit dieser Runde ohnehin
     erhalten, und die Kategorie steht weiterhin rechts als Empfehlung. */
  function reinerKategorieIntent(query) {
    var text = String(query == null ? '' : query).trim();
    if (!text) return false;
    var a;
    try { a = analyze(text); } catch (fehler) { return false; }
    if (a.identifier) return false;                 /* Artikelnummer/EAN */
    if (a.marke) return false;                      /* erkannte Marke */
    if (a.serien.length) return false;              /* erkannte Serie */
    if (a.strukturiert) return false;               /* Watt/Farbcode/Sockel/Laenge */
    if (/\d{4,}/.test(a.norm)) return false;        /* Nummernfolge jeder Art */
    if (/\d{2,5}k\b|\d{2,6}lm\b|\d{1,3}v\b/.test(a.norm)) return false; /* Kelvin/Lumen/Spannung */
    if (/\bevg\b|\bkvg\b|\bvvg\b|\bdimmbar\b|\bnicht dimmbar\b/.test(a.norm)) return false;
    return true;
  }

  /* ============ Serien-Route MIT technischen Merkmalen (Chris 2026-08-13) ==
     Phase 7/17 des Struktur-/Bestseller-Auftrags: "Dulux L 36W" DARF wieder
     auf die Familien-Collection routen — aber nur, wenn JEDES Suchwort
     entweder zur Serienfamilie gehoert oder als Collection-Filter mitreist
     (Watt; Kelvin; Farbcode 827/830/840/865, den die Serienaufloesung in
     einen Kelvin-Filter uebersetzt; Sockel = die Familie selbst; "led" =
     die LED-Variante der Familie). Merkmale, die NICHT als Filter mitreisen
     (Laenge, Lumen, Beam, Dimmbar, EVG/KVG, ausdrueckliche Ersatzabsicht,
     Marke), blockieren die Route — der Kunde bleibt in der Produktsuche.
     Der Aufrufer prueft zusaetzlich am Intent-Objekt, dass wirklich die
     SERIENAUFLOESUNG geantwortet hat (intent.productGrouping.family) —
     generische Alias-Routen (TUV, Puritec, …) routen weiterhin NICHT. */
  var ROUTE_FARB = { '827': 1, '830': 1, '840': 1, '865': 1 };

  function serienRouteMitTechnik(query) {
    var text = String(query == null ? '' : query).trim();
    if (!text) return false;
    var a;
    try { a = analyze(text); } catch (fehler) { return false; }
    if (a.identifier || a.marke || !a.serien.length) return false;
    if (/\bevg\b|\bkvg\b|\bvvg\b|\bdimmbar\b/.test(a.norm)) return false;
    if (a.tech && (a.tech.laenge || a.tech.lumen !== null
        || (a.tech.beam !== null && a.tech.beam !== undefined)
        || a.tech.ersatzAbsichtStark)) return false;
    if (a.tech && a.tech.farbcode && !ROUTE_FARB[String(a.tech.farbcode)]) return false;
    var strukturell = objekt(null);
    (a.strukturTokens || []).forEach(function (k) {
      if (k.art === 'watt' || k.art === 'kelvin' || k.art === 'farbcode' || k.art === 'sockel') {
        strukturell[k.t] = 1;
      }
    });
    for (var i = 0; i < a.tokens.length; i++) {
      var t = a.tokens[i];
      if (strukturell[t]) continue;
      if (t === 'led') continue;
      var seriell = false;
      for (var s = 0; s < a.serien.length; s++) {
        if (a.serien[s].muster.test(t)) { seriell = true; break; }
      }
      if (!seriell) return false;
    }
    return true;
  }

  /* ========== Familien-Route MIT technischen Merkmalen (Chris 2026-08-14) ==
     Collection-First, dritte Tuer: Eine ALIAS-/FAMILIENROUTE der Engine
     ("18W Leuchtstoffroehre", "GU10 50W 927 120°") darf routen, wenn JEDES
     Suchwort entweder das Kategorien-/Familienwort selbst ist, "led", oder
     ein Strukturmerkmal, das NACHWEISLICH als Collection-Filter mitreist
     (Watt real/Ersatz, Kelvin, Farbcode direkt, Sockel = Familienwahl,
     Abstrahlwinkel; Laenge nur, wenn die Ziel-Collection selbst eine
     Laengen-Collection ist — die length_mm-Facette ist live als wirkungslos
     belegt). ANLASS (live gemessen 2026-08-14): "18W Leuchtstoffroehre" auf
     /search hat 1.050 Kandidaten auf 42 Seiten, der Options-A-Rang-8-Artikel
     1000112330 steht auf SEITE 2 und ist fuer die Seite-1-Nachsortierung
     unsichtbar; die Collection-Route zeigt ihn auf Platz 1 von 37 Artikeln
     auf EINER Seite. Blockiert bleiben (Phase-13-Negativfaelle): Zubehoer-/
     Leuchten-Zusatzworte ("2G11 Fassung" waere 79 Lampen und 0 Fassungen,
     "GU10 Leuchte" 304 Lampen und 0 Leuchten), Marken, Serien (Tuer 2),
     Identifier, EVG/KVG/VVG, dimmbar (Facette unbelegt), Lumen (unbelegt),
     ausdrueckliche Ersatzworte und jedes unerklaerte Restwort.
     Lieber /search als eine zu breite falsche Collection. */
  var FAMILIE_VERBOT = /\b(?:fassung|halter|halterung|leuchte|sockel|adapter|zubehoer|kabel|klemme|verbinder|steckdose|schalter|dimmer|trafo|transformator|treiber|netzteil|starter|vorschaltgeraet|betriebsgeraet|zuendgeraet|sensor|fernbedienung|ladegeraet|batterie|akku|knopfzelle)\b/;
  var FAMILIE_WORT = objekt({
    'stick':1, 'kerze':1, 'kerzenform':1, 'kerzenlampe':1, 'kerzenlampen':1, 'tropfen':1, 'tropfenform':1, 'tropfenlampe':1, 'tropfenlampen':1, 'globe':1, 'globelampe':1, 'globelampen':1, 'filament':1, 'edison':1, 'edisonform':1, 'birne':1, 'gluehbirne':1, 'gluehbirnen':1, 'gluehlampe':1, 'gluehlampen':1,
    'roehre': 1, 'leuchtroehre': 1, 'leuchtstoffroehre': 1, 'neonroehre': 1,
    'roehrenlampe': 1, 'tube': 1, 'leuchtroehren': 1, 'leuchtstoffroehren': 1,
    'neonroehren': 1, 'roehrenlampen': 1, 'leuchtstofflampe': 1, 'leuchtstofflampen': 1,
    'lampe': 1, 'leuchtmittel': 1, 'spot': 1, 'strahler': 1, 'reflektor': 1,
    'reflektoren': 1, 'leuchtstoff': 1, 't5': 1, 't8': 1, 't9': 1, 't12': 1
  });

  function familienRouteMitTechnik(query, intent) {
    if (!intent || intent.mode !== 'route' || !intent.targetUrl) return false;
    if (intent.reason !== 'family-rule' && intent.reason !== 'alias-rule') return false;
    var text = String(query == null ? '' : query).trim();
    if (!text) return false;
    var a;
    try { a = analyze(text); } catch (fehler) { return false; }
    if (a.identifier) return false;
    var brandGesichert = !a.marke || /(?:\?|&)filter\.p\.(?:m\.specs\.)?vendor=/.test(intent.targetUrl)
      || String(intent.targetUrl).split('?')[0].indexOf('/collections/' + a.marke.key + '-') === 0;
    if (!brandGesichert) return false;
    if (a.serien.length) return false;              /* Serien entscheidet Tuer 2 */
    if (/\bevg\b|\bkvg\b|\bvvg\b|\bdimmbar\b|\bnicht dimmbar\b/.test(a.norm)) return false;
    if (FAMILIE_VERBOT.test(a.norm)) return false;
    var pfad = String(intent.targetUrl).split('?')[0];
    var laengenCollection = /-(?:\d+-cm|\d+mm)$/.test(pfad);
    if (a.tech) {
      if (a.tech.lumen !== null && a.tech.lumen !== undefined) return false;
      if (a.tech.ersatzAbsichtStark) return false;
      if (a.tech.laenge && !laengenCollection) return false;
    }
    var strukturell = objekt(null);
    (a.strukturTokens || []).forEach(function (k) {
      if (k.art === 'watt' || k.art === 'kelvin' || k.art === 'farbcode'
          || k.art === 'sockel' || k.art === 'beam'
          || (k.art === 'laenge' && laengenCollection)) {
        strukturell[k.t] = 1;
      }
    });
    for (var i = 0; i < a.tokens.length; i++) {
      var t = a.tokens[i];
      if (strukturell[t]) continue;
      if (t === 'led' || t === 'halogen') continue;  /* Technologiewort = Familienwahl */
      if (FAMILIE_WORT[t]) continue;
      if (a.marke && brandGesichert && t === a.marke.key) continue;
      return false;
    }
    return true;
  }

  /* Gemeinsame Routing-Entscheidung fuer Router, Enter-Pfad und Dropdown:
     reiner Kategorie-Intent ODER Serienfamilie mit mitreisenden Filtern
     ODER Alias-/Familienroute, deren Merkmale vollstaendig als Filter
     mitreisen (Tuer 3, Chris 2026-08-14). */
  function routingErlaubt(query, intent) {
    /* Chris 2026-08-16: Ein exakter Collectiontreffer ist der reinste
       Kategorie-Intent ueberhaupt und muss vor dem strukturiert-Gate stehen.
       reinerKategorieIntent() verwirft ihn sonst, weil ein Sockelname wie
       "E27" als strukturiertes Merkmal zaehlt — "E27 Leuchtmittel" landete
       dadurch auf /search statt in der Kategorie (Owner-Befund 2026-08-16).
       Sicher, weil part-6 diesen Zweig nur setzt, wenn die GESAMTE Anfrage
       per strictNormalize identisch zu Collectiontitel oder -handle ist und
       die Ziel-URL KEINE Filter traegt (collectionUrl(handle, [])).
       "E27 100W 827" kann reason='exact-collection' nicht erreichen.
       BEWUSST ENG: Nur das strukturiert-Gate wird uebersprungen. Artikel-
       nummer, Marke und Serie bleiben blockierend — "Osram" oder "Philips"
       routen also weiterhin NICHT in die gleichnamige Collection, damit sich
       das Verhalten von Marken- und Serienanfragen hier nicht mitaendert. */
    if (intent && intent.reason === 'exact-collection') {
      var exakt = null;
      try { exakt = analyze(query); } catch (fehler) { exakt = null; }
      if (exakt && !exakt.identifier && !exakt.marke && !exakt.serien.length) return true;
    }
    if (reinerKategorieIntent(query)) return true;
    if (intent && intent.mode === 'route' && intent.productGrouping
      && intent.productGrouping.family && serienRouteMitTechnik(query)) return true;
    return familienRouteMitTechnik(query, intent);
  }

  window.LMMRelevance = {
    version: '2026.08.14-lampenspec-1',
    harteBedingungen: harteBedingungen,
    sockelStufe: sockelStufe,
    bucketBekannt: bucketBekannt,
    reinerKategorieIntent: reinerKategorieIntent,
    serienRouteMitTechnik: serienRouteMitTechnik,
    familienRouteMitTechnik: familienRouteMitTechnik,
    routingErlaubt: routingErlaubt,
    familieVonQuery: familieVonQuery,
    familieTrifft: familieTrifft,
    wattStufe: wattStufe,
    kelvinStufe: kelvinStufe,
    lumenStufe: lumenStufe,
    bucketVonProdukt: bucketVonProdukt,
    gruppeBelegt: gruppeBelegt,
    merkmaleAufloesen: merkmaleAufloesen,
    konflikte: function () { return tfKonflikte.slice(0); },
    bucketStufe: bucketStufe,
    anwendungStufe: anwendungStufe,
    technologieVonQuery: technologieVonQuery,
    normalize: normalize,
    tokens: tokens,
    wesentlich: wesentlich,
    strukturKandidaten: strukturKandidaten,
    strukturellErfuellteTokens: strukturellErfuellteTokens,
    analyze: analyze,
    rank: rank,
    vergleiche: vergleiche,
    identifierQuery: identifierQuery,
    identAnzeige: identAnzeige,
    feldSuche: feldSuche,
    identGleich: identGleich,
    gtinGleich: gtinGleich,
    erkenneMarke: erkenneMarke,
    erkenneSerien: erkenneSerien,
    synonymeFuer: synonymeFuer,
    SCHLUESSEL: SCHLUESSEL,
    KLASSE: KLASSE
  };
})();

